(() => {
  "use strict";
  var __webpack_exports__ = {};
  (function (Parseq) {
    function make_reason(factory_name, excuse, evidence) {
      const reason = new Error(
        "parseq." + factory_name + (excuse === undefined ? "" : ": " + excuse)
      );
      reason.evidence = evidence;
      return reason;
    }

    function get_array_length(array, factory_name) {
      if (Array.isArray(array)) {
        return array.length;
      }
      if (array === undefined) {
        return 0;
      }
      throw make_reason(factory_name, "Not an array.", array);
    }

    function check_callback(callback, factory_name) {
      if (typeof callback !== "function" || callback.length !== 2) {
        throw make_reason(factory_name, "Not a callback function.", callback);
      }
    }

    function check_requestors(requestor_array, factory_name) {
      if (
        requestor_array.some(function (requestor) {
          return (
            typeof requestor !== "function" ||
            requestor.length < 1 ||
            requestor.length > 2
          );
        })
      ) {
        throw make_reason(
          factory_name,
          "Bad requestors array.",
          requestor_array
        );
      }
    }

    function run(
      factory_name,
      requestor_array,
      initial_value,
      action,
      timeout,
      time_limit,
      throttle = 0
    ) {
      let cancel_array = new Array(requestor_array.length);
      let next_number = 0;
      let timer_id;

      function cancel(reason = make_reason(factory_name, "Cancel.")) {
        if (timer_id !== undefined) {
          clearTimeout(timer_id);
          timer_id = undefined;
        }
        if (cancel_array !== undefined) {
          cancel_array.forEach(function (cancel) {
            try {
              if (typeof cancel === "function") {
                return cancel(reason);
              }
            } catch (ignore) {}
          });
          cancel_array = undefined;
        }
      }

      function start_requestor(value) {
        if (
          cancel_array !== undefined &&
          next_number < requestor_array.length
        ) {
          let number = next_number;
          next_number += 1;
          const requestor = requestor_array[number];
          try {
            cancel_array[number] = requestor(function start_requestor_callback(
              value,
              reason
            ) {
              if (cancel_array !== undefined && number !== undefined) {
                cancel_array[number] = undefined;
                action(value, reason, number);
                number = undefined;
                setTimeout(
                  start_requestor,
                  0,
                  factory_name === "sequence" ? value : initial_value
                );
              }
            },
            value);
          } catch (exception) {
            action(undefined, exception, number);
            number = undefined;
            start_requestor(value);
          }
        }
      }
      if (time_limit !== undefined) {
        if (typeof time_limit === "number" && time_limit >= 0) {
          if (time_limit > 0) {
            timer_id = setTimeout(timeout, time_limit);
          }
        } else {
          throw make_reason(factory_name, "Bad time limit.", time_limit);
        }
      }
      if (!Number.isSafeInteger(throttle) || throttle < 0) {
        throw make_reason(factory_name, "Bad throttle.", throttle);
      }
      let repeat = Math.min(throttle || Infinity, requestor_array.length);
      while (repeat > 0) {
        setTimeout(start_requestor, 0, initial_value);
        repeat -= 1;
      }
      return cancel;
    }

    function parallel(
      required_array,
      optional_array,
      time_limit,
      time_option,
      throttle,
      factory_name = "parallel"
    ) {
      let requestor_array;
      let number_of_required = get_array_length(required_array, factory_name);
      if (number_of_required === 0) {
        if (get_array_length(optional_array, factory_name) === 0) {
          requestor_array = [];
        } else {
          requestor_array = optional_array;
          time_option = true;
        }
      } else {
        if (get_array_length(optional_array, factory_name) === 0) {
          requestor_array = required_array;
          time_option = undefined;
        } else {
          requestor_array = required_array.concat(optional_array);
          if (time_option !== undefined && typeof time_option !== "boolean") {
            throw make_reason(factory_name, "Bad time_option.", time_option);
          }
        }
      }
      check_requestors(requestor_array, factory_name);
      return function parallel_requestor(callback, initial_value) {
        check_callback(callback, factory_name);
        let number_of_pending = requestor_array.length;
        let number_of_pending_required = number_of_required;
        let results = [];
        if (number_of_pending === 0) {
          callback(factory_name === "sequence" ? initial_value : results);
          return;
        }
        let cancel = run(
          factory_name,
          requestor_array,
          initial_value,
          function parallel_action(value, reason, number) {
            results[number] = value;
            number_of_pending -= 1;
            if (number < number_of_required) {
              number_of_pending_required -= 1;
              if (reason) {
                cancel(reason);
                callback(undefined, reason);
                callback = undefined;
                return;
              }
            }
            if (
              number_of_pending < 1 ||
              (time_option === undefined && number_of_pending_required < 1)
            ) {
              cancel(make_reason(factory_name, "Optional."));
              callback(factory_name === "sequence" ? results.pop() : results);
              callback = undefined;
            }
          },
          function parallel_timeout() {
            const reason = make_reason(factory_name, "Timeout.", time_limit);
            if (time_option === false) {
              time_option = undefined;
              if (number_of_pending_required < 1) {
                cancel(reason);
                callback(results);
              }
            } else {
              cancel(reason);
              if (number_of_pending_required < 1) {
                callback(results);
              } else {
                callback(undefined, reason);
              }
              callback = undefined;
            }
          },
          time_limit,
          throttle
        );
        return cancel;
      };
    }

    function parallel_object(
      required_object,
      optional_object,
      time_limit,
      time_option,
      throttle
    ) {
      const names = [];
      let required_array = [];
      let optional_array = [];
      if (required_object) {
        if (typeof required_object !== "object") {
          throw make_reason(
            "parallel_object",
            "Type mismatch.",
            required_object
          );
        }
        Object.keys(required_object).forEach(function (name) {
          let requestor = required_object[name];
          if (
            typeof requestor === "function" &&
            (requestor.length === 1 || requestor.length === 2)
          ) {
            names.push(name);
            required_array.push(requestor);
          }
        });
      }
      if (optional_object) {
        if (typeof optional_object !== "object") {
          throw make_reason(
            "parallel_object",
            "Type mismatch.",
            optional_object
          );
        }
        Object.keys(optional_object).forEach(function (name) {
          let requestor = optional_object[name];
          if (
            typeof requestor === "function" &&
            (requestor.length === 1 || requestor.length === 2)
          ) {
            if (required_object && required_object[name] !== undefined) {
              throw make_reason("parallel_object", "Duplicate name.", name);
            }
            names.push(name);
            optional_array.push(requestor);
          }
        });
      }
      const parallel_requestor = parallel(
        required_array,
        optional_array,
        time_limit,
        time_option,
        throttle,
        "parallel_object"
      );
      return function parallel_object_requestor(callback, initial_value) {
        return parallel_requestor(function parallel_object_callback(
          value,
          reason
        ) {
          if (value === undefined) {
            return callback(undefined, reason);
          }
          const object = Object.create(null);
          names.forEach(function (name, index) {
            object[name] = value[index];
          });
          return callback(object);
        },
        initial_value);
      };
    }

    function race(requestor_array, time_limit, throttle) {
      const factory_name = throttle === 1 ? "fallback" : "race";
      if (get_array_length(requestor_array, factory_name) === 0) {
        throw make_reason(factory_name, "No requestors.");
      }
      check_requestors(requestor_array, factory_name);
      return function race_requestor(callback, initial_value) {
        check_callback(callback, factory_name);
        let number_of_pending = requestor_array.length;
        let cancel = run(
          factory_name,
          requestor_array,
          initial_value,
          function race_action(value, reason, number) {
            number_of_pending -= 1;
            if (value !== undefined) {
              cancel(make_reason(factory_name, "Loser.", number));
              callback(value);
              callback = undefined;
            } else if (number_of_pending < 1) {
              cancel(reason);
              callback(undefined, reason);
              callback = undefined;
            }
          },
          function race_timeout() {
            let reason = make_reason(factory_name, "Timeout.", time_limit);
            cancel(reason);
            callback(undefined, reason);
            callback = undefined;
          },
          time_limit,
          throttle
        );
        return cancel;
      };
    }

    function fallback(requestor_array, time_limit) {
      return race(requestor_array, time_limit, 1);
    }

    function sequence(requestor_array, time_limit) {
      return parallel(
        requestor_array,
        undefined,
        time_limit,
        undefined,
        1,
        "sequence"
      );
    }
    Parseq.export = function () {
      return Object.freeze({
        fallback,
        parallel,
        parallel_object,
        race,
        sequence,
      });
    };
  })((PLUG.Parseq = Object.create(null)));
  (function (Wishlist) {
    const plugButtonClass = "plug-fav-button";
    const plugCardButtonClass = "plug-fav-button--card";
    let listId;
    PLUG.cachedWishlist = PLUG.cachedWishlist ? PLUG.cachedWishlist : undefined;
    const getWishlistProducts = () =>
      new Promise((resolve, reject) => {
        function run() {
          window._swat.fetchWrtEventTypeET(
            (products) => resolve(products),
            window._swat.EventTypes.addToWishlist
          );
        }
        try {
          if (window._swat) {
            run();
          } else {
            if (!window.SwymCallbacks) {
              window.SwymCallbacks = [];
            }
            window.SwymCallbacks.push(run);
          }
        } catch (exception) {
          return reject(exception);
        }
      });
    const fetchListId = () =>
      new Promise((resolve) => {
        function run() {
          window._swat.fetchLists({
            callbackFn: (lists) => {
              if (lists.length) {
                resolve(lists[0].lid);
              } else {
                window._swat.createList(
                  {
                    lname: "Wishlist",
                  },
                  function onSuccess(newList) {
                    resolve(newList.lid);
                  },
                  function onError(error) {
                    console.error(error);
                  }
                );
              }
            },
            errorFn: (error) => {
              console.error(error);
            },
          });
        }
        if (window._swat) {
          run();
        } else {
          if (!window.SwymCallbacks) {
            window.SwymCallbacks = [];
          }
          window.SwymCallbacks.push(run);
        }
      });
    const showAddedAlert = (productId, variantId, message, imageUrl) => {
      try {
        window._swat.ui.uiRef.showNotification({
          epi: variantId,
          empi: productId,
          message,
          image: imageUrl,
          onClick: () => {
            _swat.ui.uiRef.showWishlistModal();
          },
        });
      } catch (e) {
        console.log(e);
      }
    };
    const addProductToWishlist = async (
      productId,
      variantId,
      productUrl,
      successMessage,
      productImage
    ) => {
      if (!listId) {
        listId = await fetchListId();
      }
      return new Promise((resolve, reject) => {
        function run() {
          window._swat.addToList(
            listId,
            {
              epi: variantId,
              empi: productId,
              du: productUrl,
            },
            function onSuccess(addedListItem) {
              console.log("Added item to wishlist", addedListItem);
              PLUG.cachedWishlist.push(addedListItem);
              if (successMessage) {
                showAddedAlert(
                  productId,
                  variantId,
                  successMessage,
                  productImage
                );
              }
              resolve();
            },
            function onError(error) {
              console.error(error);
              reject();
            }
          );
        }
        if (window._swat) {
          run();
        } else {
          if (!window.SwymCallbacks) {
            window.SwymCallbacks = [];
          }
          window.SwymCallbacks.push(run);
        }
      });
    };
    const removeProductFromWishlist = async (
      productId,
      variantId,
      productUrl
    ) => {
      if (!listId) {
        listId = await fetchListId();
      }
      return new Promise((resolve, reject) => {
        function run() {
          window._swat.deleteFromList(
            listId,
            {
              epi: variantId,
              empi: productId,
              du: productUrl,
            },
            function onSuccess(addedListItem) {
              console.log("Removed item from wishlist", addedListItem);
              PLUG.cachedWishlist = PLUG.cachedWishlist.filter(
                (prod) => prod.empi !== productId
              );
              resolve();
            },
            function onError(error) {
              console.error(error);
              reject();
            }
          );
        }
        if (window._swat) {
          run();
        } else {
          if (!window.SwymCallbacks) {
            window.SwymCallbacks = [];
          }
          window.SwymCallbacks.push(run);
        }
      });
    };
    const updateAllFavoriteButtons = async () => {
      if (!PLUG.cachedWishlist) {
        PLUG.cachedWishlist = await getWishlistProducts();
      }
      const favButtons = Array.from(
        document.getElementsByClassName(plugButtonClass)
      );
      favButtons.forEach((button) => {
        const productId = Number(button.dataset.productId);
        if (PLUG.cachedWishlist.some((product) => product.empi === productId)) {
          button.classList.add("is-selected");
        } else {
          button.classList.remove("is-selected");
        }
      });
    };
    const buildHeartIcon = (id) => {
      const ns = "http://www.w3.org/2000/svg";
      const svg = document.createElementNS(ns, "svg");
      svg.setAttribute("aria-hidden", "true");
      svg.setAttribute("focusable", "false");
      svg.setAttribute("role", "presentation");
      svg.setAttribute("class", "icon heart-icon");
      svg.setAttribute("viewBox", "0 0 14 14");
      svg.setAttribute("width", "14");
      svg.setAttribute("height", "14");
      const path = document.createElementNS(ns, "path");
      path.setAttribute(
        "d",
        "M7.36199 12.1394C7.16366 12.2094 6.83699 12.2094 6.63866 12.1394C4.94699 11.5619 1.16699 9.15276 1.16699 5.06943C1.16699 3.26693 2.61949 1.80859 4.41033 1.80859C5.47199 1.80859 6.41116 2.32193 7.00033 3.11526C7.58949 2.32193 8.53449 1.80859 9.59033 1.80859C11.3812 1.80859 12.8337 3.26693 12.8337 5.06943C12.8337 9.15276 9.05366 11.5619 7.36199 12.1394Z"
      );
      path.setAttribute("fill", `url(#${id})`);
      svg.appendChild(path);
      const defs = document.createElementNS(ns, "defs");
      const linearGradient = document.createElementNS(ns, "linearGradient");
      linearGradient.setAttribute("id", id);
      linearGradient.setAttribute("x1", "3.50033");
      linearGradient.setAttribute("y1", "1.7502");
      linearGradient.setAttribute("x2", "9.33366");
      linearGradient.setAttribute("y2", "12.2502");
      linearGradient.setAttribute("gradientUnits", "userSpaceOnUse");
      const stop1 = document.createElementNS(ns, "stop");
      stop1.setAttribute("stop-color", "#ff8484");
      const stop2 = document.createElementNS(ns, "stop");
      stop2.setAttribute("stop-color", "#ff0000");
      stop2.setAttribute("offset", "1");
      linearGradient.appendChild(stop1);
      linearGradient.appendChild(stop2);
      defs.appendChild(linearGradient);
      svg.appendChild(defs);
      return svg;
    };
    const addListenerToFavButton = (favButton) => {
      if (favButton.dataset.hasListeners === "true") {
        return;
      }
      favButton.dataset.hasListeners = "true";
      const productId = Number(favButton.dataset.productId);
      const variantId = Number(favButton.dataset.variantId);
      const productTitle = favButton.dataset.productTitle;
      const productImage = favButton.dataset.productImage;
      const productUrl = favButton.dataset.productUrl;
      favButton.addEventListener(
        "click",
        (e) => {
          e.stopImmediatePropagation();
          e.stopPropagation();
          favButton.disabled = true;
          if (favButton.classList.contains("is-selected")) {
            removeProductFromWishlist(
              Number(productId),
              Number(variantId),
              productUrl
            )
              .catch((err) => console.error(err))
              .finally(() => {
                favButton.disabled = false;
              });
            favButton.classList.remove("is-selected");
          } else {
            addProductToWishlist(
              Number(productId),
              Number(variantId),
              productUrl,
              `<strong>${productTitle}</strong> has been added to your wishlist!`,
              productImage
            )
              .catch((err) => console.error(err))
              .finally(() => {
                favButton.disabled = false;
              });
            favButton.classList.add("is-selected");
          }
        },
        false
      );
    };
    const buildCardFavButton = (
      productId,
      variantId,
      productUrl,
      productTitle,
      productImage
    ) => {
      const favButton = document.createElement("button");
      favButton.className = `${plugButtonClass} ${plugCardButtonClass}`;
      favButton.dataset.productId = productId;
      favButton.dataset.variantId = variantId;
      favButton.dataset.productUrl = productUrl;
      favButton.dataset.productTitle = productTitle;
      favButton.dataset.productImage = productImage;
      favButton.appendChild(buildHeartIcon(`c-card-${productId}-${variantId}`));
      addListenerToFavButton(favButton);
      return favButton;
    };
    const initWishlistButtons = (containerSelector) => {
      const container = containerSelector
        ? document.querySelector(containerSelector)
        : document.body;
      const buttons = Array.from(
        container.getElementsByClassName("plug-fav-button")
      );
      buttons.forEach(addListenerToFavButton);
    };
    Wishlist.export = function () {
      return Object.freeze({
        getWishlistProducts,
        initWishlistButtons,
        addProductToWishlist,
        removeProductFromWishlist,
        updateAllFavoriteButtons,
        buildHeartIcon,
        addListenerToFavButton,
        buildCardFavButton,
      });
    };
  })((PLUG.Wishlist = Object.create(null)));
  (function (Utils) {
    "use strict";

    function getUrlParam(name, queryString = location.search) {
      if (queryString.charAt(0) === "?") {
        queryString = queryString.slice(1);
      }
      const paramMatch = queryString.split("&").find(function (param) {
        return param.split("=")[0] === name;
      });
      return paramMatch !== undefined ? paramMatch.split("=")[1] : undefined;
    }

    function setUrlParam(queryString, name, value) {
      if (queryString.charAt(0) === "?") {
        queryString = queryString.slice(1);
      }
      if (getUrlParam(name, queryString) !== undefined) {
        const params = queryString.split("&");
        let paramIndex;
        params.forEach(function (param, index) {
          if (param.split("=")[0] === name) {
            paramIndex = index;
          }
          return param.split("=")[0] === name;
        });
        params[paramIndex] = name + "=" + value;
        return "?" + params.join("&");
      }
      return queryString !== ""
        ? `?${queryString}&${name}=${value}`
        : `?${name}=${value}`;
    }

    function removeUrlParam(queryString, name) {
      if (queryString.charAt(0) === "?") {
        queryString = queryString.slice(1);
      }
      if (getUrlParam(name, queryString) !== undefined) {
        const params = queryString.split("&").filter(function (keyValueString) {
          const keyValuePair = keyValueString.split("=");
          return keyValuePair[0] !== name;
        });
        return params.length ? "?" + params.join("&") : "";
      }
    }

    function isMobile(breakpoint = PLUG.breakpoints["tablet-md"]) {
      return window.innerWidth < breakpoint;
    }

    function waitUntilTrue(testFcn, cb, interval = 200, limit = 50) {
      if (testFcn()) {
        return cb();
      }
      limit -= 1;
      if (limit === 0) {
        return cb(undefined, "timeout");
      }
      setTimeout(waitUntilTrue, interval, testFcn, cb, interval, limit);
    }
    const getAllNonBuiltInProperties = (obj) => {
      const properties = new Set();
      (function getNonBuiltInProperties(obj) {
        Reflect.ownKeys(obj).forEach((key) => {
          properties.add([obj, key]);
        });
        obj = Reflect.getPrototypeOf(obj);
        if (obj !== Object.prototype) {
          getNonBuiltInProperties(obj);
        }
      })(obj);
      return properties;
    };
    const bindThisToAllMethods = function (obj, include, exclude) {
      const filter = (key) => {
        const match = (pattern) =>
          typeof pattern === "string" ? key === pattern : pattern.test(key);
        return include
          ? include.some(match)
          : exclude
          ? !exclude.some(match)
          : true;
      };
      for (const [object, key] of getAllNonBuiltInProperties(
        obj.constructor.prototype
      )) {
        if (key === "constructor" || !filter(key)) {
          continue;
        }
        const descriptor = Reflect.getOwnPropertyDescriptor(object, key);
        if (descriptor && typeof descriptor.value === "function") {
          obj[key] = obj[key].bind(obj);
        }
      }
      return obj;
    };
    const getCookie = function (name) {
      return document.cookie.split("; ").find(function (cookieString) {
        return cookieString.split("=")[0] === name;
      });
    };
    const setCookie = function (name, value, maxAgeInSeconds, options) {
      let cookieString = `${name}=${value}`;
      if (maxAgeInSeconds) {
        cookieString += `; max-age=${maxAgeInSeconds}`;
      }
      Object.keys(options).forEach((optionKey) => {
        cookieString += `; ${optionKey}=${options[optionKey]}`;
      });
      document.cookie = cookieString;
    };

    function filterArray(inputArray, filter) {
      const outputArray = [];
      if (!inputArray.length) {
        return outputArray;
      }
      let k = 0;
      while (k < inputArray.length) {
        if (filter(inputArray[k], k, inputArray)) {
          outputArray.push(inputArray[k]);
        }
        k += 1;
      }
      return outputArray;
    }

    function mapArray(inputArray, map) {
      const outputArray = [];
      if (!inputArray.length) {
        return outputArray;
      }
      let k = 0;
      while (k < inputArray.length) {
        outputArray[k] = map(inputArray[k], k);
        k += 1;
      }
      return outputArray;
    }

    function forEach(inputArray, fcn) {
      if (inputArray.length) {
        let k = 0;
        while (k < inputArray.length) {
          fcn(inputArray[k], k, inputArray);
          k += 1;
        }
      }
    }

    function find(inputArray, fcn, returnIndex = false) {
      if (inputArray.length) {
        let k = 0;
        while (k < inputArray.length) {
          if (fcn(inputArray[k], k, inputArray)) {
            return returnIndex ? k : inputArray[k];
          }
          k += 1;
        }
      }
    }
    const Parseq = PLUG.import("Parseq");
    const Wishlist = PLUG.import("Wishlist");

    function capitalize(str) {
      const chars = str.split("");
      chars[0] = chars[0].toUpperCase();
      return chars.join("");
    }

    function camelCase(str, capitalizeFirstLetter = true) {
      const sepRegex = /[ -_]+/g;
      const parts = str.split(sepRegex).map(capitalize);
      if (!capitalizeFirstLetter) {
        parts[0] = parts[0].toLowerCase();
      }
      return parts.join("");
    }
    const isoCodeToPrefix = {
      HKD: "HK",
      CAD: "C",
      NZD: "NZ",
      SGD: "S",
      AUD: "A",
    };

    function formatMoney(price, useCents = true) {
      let money;
      if (PLUG.moneyFormat.includes("{{amount}}")) {
        money = PLUG.moneyFormat.replace(
          "{{amount}}",
          (useCents ? price / 100 : price).toFixed(2)
        );
        let decimalIndex = 0;
        while (decimalIndex < money.length) {
          if (money[decimalIndex] === ".") {
            break;
          }
          decimalIndex += 1;
        }
        const numDigitsToLeftOfDecimal = decimalIndex;
        if (numDigitsToLeftOfDecimal > 3) {
          money = money.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
      } else if (PLUG.moneyFormat.includes("{{amount_with_comma_separator}}")) {
        money = PLUG.moneyFormat
          .replace(
            "{{amount_with_comma_separator}}",
            (useCents ? price / 100 : price).toFixed(2)
          )
          .replace(".", ",");
      } else {
        money = PLUG.moneyFormat.replace(
          "{{amount_no_decimals}}",
          (useCents ? price / 100 : price).toFixed(2)
        );
      }
      return Object.keys(isoCodeToPrefix).includes(PLUG.selectedCurrency)
        ? isoCodeToPrefix[PLUG.selectedCurrency] + money
        : money;
    }

    function formatImageSource(baseSrc, dimensions) {
      let imageSource = baseSrc;
      dimensions = dimensions.split("x");
      if (imageSource.includes("?")) {
        const parts = imageSource.split("?");
        if (dimensions[0]) {
          parts[1] = setUrlParam(parts[1], "width", dimensions[0]).replace(
            "?",
            ""
          );
        }
        if (dimensions[1]) {
          parts[1] = setUrlParam(parts[1], "height", dimensions[1]).replace(
            "?",
            ""
          );
        }
        imageSource = parts.join("?");
      } else {
        if (dimensions[0] && dimensions[1]) {
          imageSource = `${imageSource}?width=${dimensions[0]}&height=${dimensions[1]}`;
        } else if (dimensions[0]) {
          imageSource = `${imageSource}?width=${dimensions[0]}`;
        } else {
          imageSource = `${imageSource}?height=${dimensions[0]}`;
        }
      }
      return imageSource;
    }

    function formatImageSrcset(src, maxWidth, breakpoints, buildSrc) {
      if (!buildSrc) {
        buildSrc = formatImageSource;
      }
      const srcset = [];
      breakpoints.forEach((breakpoint) => {
        if (maxWidth < breakpoint) {
          return;
        }
        const url = buildSrc(src, `${breakpoint}x`);
        srcset.push(`${url} ${breakpoint}w`);
      });
      return srcset.join(", ");
    }

    function afterNextRepaint(fcn) {
      window.requestAnimationFrame(function () {
        setTimeout(fcn, 0);
      });
    }

    function addClasses(elements, ...classes) {
      let k = 0;
      while (k < elements.length) {
        elements[k].classList.add(...classes);
        k += 1;
      }
    }

    function removeClasses(elements, ...classes) {
      let k = 0;
      while (k < elements.length) {
        elements[k].classList.remove(...classes);
        k += 1;
      }
    }

    function extractElement(element) {
      return element.parentElement.removeChild(element);
    }

    function replaceElement(oldElement, newElement) {
      oldElement.parentElement.insertBefore(newElement, oldElement);
      return extractElement(oldElement);
    }

    function removeChildren(parent, requiredClass = "") {
      const children = Array.from(parent.children);
      let k = 0;
      while (k < children.length) {
        const childK = children[k];
        if (!requiredClass || childK.classList.contains(requiredClass)) {
          parent.removeChild(childK);
        }
        k += 1;
      }
    }

    function setAttributes(ele, attributes) {
      Object.keys(attributes).forEach(function (name) {
        ele.setAttribute(name, attributes[name]);
      });
      return ele;
    }

    function loadingSvg() {
      const ns = "http://www.w3.org/2000/svg";
      const svg = document.createElementNS(ns, "svg");
      svg.setAttribute("aria-hidden", "true");
      svg.setAttribute("focusable", "false");
      svg.setAttribute("role", "presentation");
      svg.setAttribute("class", "icon spinner-icon");
      svg.setAttribute("viewBox", "0 0 20 20");
      const path = document.createElementNS(ns, "path");
      path.setAttribute(
        "d",
        "M7.229 1.173a9.25 9.25 0 1 0 11.655 11.412 1.25 1.25 0 1 0-2.4-.698 6.75 6.75 0 1 1-8.506-8.329 1.25 1.25 0 1 0-.75-2.385z"
      );
      path.setAttribute("fill", "currentColor");
      svg.appendChild(path);
      const wrapper = document.createElement("span");
      wrapper.setAttribute("data-loader", true);
      wrapper.className = "is-hidden";
      wrapper.appendChild(svg);
      return wrapper;
    }

    function setButtonLoadingState(button, loading) {
      let loader = button.querySelector("[data-loader]");
      let content = button.querySelector("[data-button-content]");
      if (!loader) {
        loader = loadingSvg();
        if (!content) {
          content = document.createElement("span");
          content.setAttribute("data-button-content", "true");
          let k = 0;
          while (k < button.childNodes.length) {
            let childNodeK = button.childNodes[k];
            if (childNodeK.nodeType === 1 || childNodeK.nodeType === 3) {
              content.appendChild(childNodeK);
            }
            k += 1;
          }
          button.appendChild(content);
        }
        button.appendChild(loader);
      }
      if (!content) {
        return;
      }
      if (loading) {
        button.disabled = true;
        content.style.opacity = "0";
        loader.classList.remove("is-hidden");
      } else {
        button.disabled = false;
        loader.classList.add("is-hidden");
        content.style.opacity = "1";
      }
    }

    function convertDomNodeToString(node) {
      const xmlSerializer = new XMLSerializer();
      return xmlSerializer.serializeToString(node);
    }

    function stringToDomNode(string) {
      const domparser = new DOMParser();
      const parsedDoc = domparser.parseFromString(string, "text/html");
      return parsedDoc.body.children[0];
    }

    function throttlerConstructor() {
      let queuedCallback;
      return function onEvent(callback) {
        if (!queuedCallback) {
          window.requestAnimationFrame(function () {
            const cb = queuedCallback;
            queuedCallback = null;
            cb();
          });
        }
        queuedCallback = callback;
      };
    }

    function listboxConstructor(listbox, onChangeCallback) {
      const btn = listbox.getElementsByClassName("listbox-btn")[0];
      const carat = btn.getElementsByTagName("svg")[0];
      const activeValue = listbox.getElementsByClassName("listbox-value")[0];
      const list = listbox.getElementsByClassName("listbox-list")[0];
      const options = Array.from(list.getElementsByTagName("li"));
      const emptyValue = listbox.dataset.emptyValue;
      const showTransitionDuration = 200;

      function show() {
        listbox.classList.add("is-open");
        carat.classList.add("is-rotated");
        requestAnimationFrame(function () {
          list.classList.add("is-showing");
        });
      }

      function hide() {
        carat.classList.remove("is-rotated");
        list.classList.remove("is-showing");
        setTimeout(function () {
          listbox.classList.remove("is-open");
        }, showTransitionDuration);
      }
      btn.addEventListener(
        "click",
        function () {
          return listbox.classList.contains("is-open") ? hide() : show();
        },
        false
      );
      options.forEach(function (option, index) {
        option.addEventListener(
          "click",
          function () {
            hide();
            if (option.getAttribute("aria-selected") !== "true") {
              activeValue.textContent = option.textContent;
              if (activeValue.textContent === emptyValue) {
                listbox.classList.add("is-empty");
              } else {
                listbox.classList.remove("is-empty");
              }
              options.forEach(function (option, j) {
                if (index === j) {
                  option.setAttribute("aria-selected", "true");
                } else {
                  option.removeAttribute("aria-selected");
                }
              });
              onChangeCallback(option, listbox);
            }
          },
          false
        );
      });

      function setValue(value) {
        const option = options.find(function (option) {
          return (
            option.dataset.value === value ||
            option.textContent === value ||
            option.textContent.toLowerCase() === value
          );
        });
        if (option && option.getAttribute("aria-selected") !== "true") {
          const optionIndex = options.indexOf(option);
          activeValue.textContent = option.textContent;
          if (activeValue.textContent === emptyValue) {
            listbox.classList.add("is-empty");
          } else {
            listbox.classList.remove("is-empty");
          }
          options.forEach(function (option, j) {
            if (optionIndex === j) {
              option.setAttribute("aria-selected", "true");
            } else {
              option.removeAttribute("aria-selected");
            }
          });
        }
      }
      let hideTimer;
      btn.addEventListener("blur", function () {
        hideTimer = setTimeout(hide, 100);
      });
      list.addEventListener("focus", function () {
        clearTimeout(hideTimer);
      });
      return Object.freeze({
        setValue,
        getValue: function () {
          return activeValue.textContent !== emptyValue
            ? activeValue.textContent
            : undefined;
        },
      });
    }

    function integer(from = 0, to = Number.MAX_SAFE_INTEGER, step = 1) {
      return function integerGenerator() {
        if (from < to) {
          const result = from;
          from += step;
          return result;
        }
      };
    }

    function element(arrayLike, gen = integer(0, arrayLike.length)) {
      return function elementGenerator(...args) {
        const elementNr = gen(...args);
        if (elementNr !== undefined) {
          return arrayLike[elementNr];
        }
      };
    }

    function makeXmlRequest(options, cb) {
      const req = new XMLHttpRequest();
      let { method, url, requestBody, headerData, responseType } = options;
      req.open(method, url, true);
      if (responseType) {
        req.responseType = responseType;
      }
      if (headerData) {
        Object.keys(headerData).forEach(function (key) {
          req.setRequestHeader(key, headerData[key]);
        });
      }
      const contentTypeSpecified =
        headerData &&
        (headerData["Content-Type"] !== undefined ||
          headerData["content-type"] !== undefined);
      if (requestBody && !contentTypeSpecified) {
        req.setRequestHeader("Content-Type", "application/json");
      }
      req.onreadystatechange = function () {
        if (req.readyState === req.DONE) {
          if (req.status.toString().charAt(0) === "2") {
            if (cb) {
              return cb(
                responseType === "document"
                  ? req.responseXML
                  : responseType === "blob"
                  ? req.response
                  : req.responseText
              );
            }
          } else {
            const errorMsg =
              "Bad request: status code: " + req.status + " " + req.results;
            if (cb) {
              console.log(errorMsg, req.response);
              return cb(undefined, errorMsg, req.response);
            } else {
              throw new Error(errorMsg);
            }
          }
        }
      };
      req.send(requestBody);
    }

    function addItemToCart(variantId, quantity, cb, lineItemProperties) {
      const item = {
        quantity,
        id: variantId,
      };
      if (lineItemProperties && Object.keys(lineItemProperties).length) {
        item["properties"] = lineItemProperties;
      }
      return makeXmlRequest(
        {
          method: "POST",
          url: "/cart/add.js",
          requestBody: JSON.stringify({
            items: [item],
          }),
          headers: {
            "Content-Type": "application/json",
          },
        },
        function done(data, reason, response) {
          if (reason) {
            if (response) {
              response = JSON.parse(response);
              const regex = /You can't add more [\w\W]+to the cart/g;
              if (
                response.message === "Cart Error" &&
                response.description.match(regex)
              ) {
                return cb(
                  undefined,
                  response.description.replace(
                    "You can't add more",
                    "You can't add that many"
                  )
                );
              } else {
                return cb(undefined, response.description);
              }
            }
            return cb(undefined, reason);
          }
          return cb();
        }
      );
    }

    function addItemsToCart(itemsArray, cb) {
      return makeXmlRequest(
        {
          method: "POST",
          url: "/cart/add.js",
          requestBody: JSON.stringify({
            items: itemsArray,
          }),
          headers: {
            "Content-Type": "application/json",
          },
        },
        function done(data, reason, response) {
          if (reason) {
            if (response) {
              response = JSON.parse(response);
              const regex = /You can't add more [\w\W]+to the cart/g;
              if (
                response.message === "Cart Error" &&
                response.description.match(regex)
              ) {
                return cb(
                  undefined,
                  response.description.replace(
                    "You can't add more",
                    "You can't add that many"
                  )
                );
              } else {
                return cb(undefined, response.description);
              }
            }
            return cb(undefined, reason);
          }
          return cb();
        }
      );
    }

    function getProduct(handle, cb) {
      try {
        return makeXmlRequest(
          {
            method: "GET",
            url: "/products/" + handle + ".js",
            headers: {
              "Content-Type": "application/json",
            },
          },
          cb
        );
      } catch (exception) {
        return cb(undefined, exception);
      }
    }

    function getFormData(form) {
      const data = Object.create(null);
      const inputTags = ["input", "select", "textarea"];
      inputTags.forEach(function (tag) {
        let matches = Array.from(form.getElementsByTagName(tag));
        matches.forEach(function (element) {
          if (
            tag === "input" &&
            element.getAttribute("type") === "checkbox" &&
            !element.checked
          ) {
            return;
          }
          data[element.getAttribute("name")] = element.value;
        });
      });
      return data;
    }

    function submitForm(options, cb) {
      try {
        const form = options.form;
        const method = options.method || "POST";
        const action =
          options.action ||
          (form
            ? form.getAttribute("action") || location.pathname
            : location.pathname);
        let data = options.data || getFormData(form);
        const urlEncodedDataPairs = Object.keys(data).map(function (key) {
          return encodeURIComponent(key) + "=" + encodeURIComponent(data[key]);
        });
        data = urlEncodedDataPairs.join("&").replace(/%20/g, "+");
        return makeXmlRequest(
          {
            method,
            url: action,
            requestBody: data,
            headerData: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          },
          cb
        );
      } catch (exception) {
        return cb(undefined, exception);
      }
    }

    function toDataUrl(url, cb) {
      makeXmlRequest(
        {
          method: "GET",
          url,
          responseType: "blob",
        },
        function done(result, reason) {
          if (reason) {
            return cb(undefined, reason);
          }
          const reader = new FileReader();
          reader.onloadend = function () {
            return cb(reader.result);
          };
          reader.readAsDataURL(result);
        }
      );
    }

    function getFreshSection(
      sectionId,
      cb,
      path = location.pathname,
      queryString = location.search
    ) {
      const url =
        queryString !== ""
          ? path + queryString + "&section_id=" + sectionId
          : path + "?section_id=" + sectionId;
      return makeXmlRequest(
        {
          method: "GET",
          url,
        },
        function done(newSectionText, reason) {
          if (reason) {
            return cb(undefined, reason);
          }
          const domparser = new DOMParser();
          const parsedDoc = domparser.parseFromString(
            newSectionText,
            "text/html"
          );
          const newSection = parsedDoc.body.children[0];
          return cb(newSection);
        }
      );
    }

    function refreshSection(sectionId, cb, path, queryString) {
      return getFreshSection(
        sectionId,
        function (newSection, reason) {
          if (newSection === undefined) {
            return cb(undefined, reason);
          }
          const oldSection = document.getElementById(
            "shopify-section-" + sectionId
          );
          if (!oldSection) {
            throw new Error("Can't find old section");
          }
          const sectionParent = oldSection.parentElement;
          sectionParent.insertBefore(newSection, oldSection);
          sectionParent.removeChild(oldSection);
          return cb();
        },
        path,
        queryString
      );
    }
    const easingFunctions = {
      easeInOutCubic: function (x) {
        return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
      },
      easeOutCubic: function (x) {
        return 1 - Math.pow(1 - x, 3);
      },
    };

    function smoothScrollTo(element, y1, cb, easingType = "easeOutCubic") {
      if (typeof y1 !== "number") {
        throw new TypeError("Argument 'y1' must be a number.");
      }
      const y0 =
        element.scrollTop !== undefined ? element.scrollTop : window.scrollY;
      y1 = Math.min(
        element.scrollHeight !== undefined
          ? element.scrollHeight
          : document.body.getBoundingClientRect().height,
        Math.max(0, y1)
      );
      const easingFunction = easingFunctions[easingType];
      const totalDistanceToScroll = y1 - y0;
      const scrollingDown = y1 > y0;
      if (y0 === y1) {
        return;
      }
      const totalDuration = 300;
      let start;

      function step(timestamp) {
        if (start === undefined) {
          start = timestamp;
        }
        const elapsed = timestamp - start;
        const percentDone = elapsed / totalDuration;
        const percentScrolled = easingFunction(percentDone);
        const yx = scrollingDown
          ? Math.min(totalDistanceToScroll * percentScrolled + y0, y1)
          : Math.max(totalDistanceToScroll * percentScrolled + y0, y1);
        element.scrollTo(0, yx);
        if (elapsed < totalDuration) {
          window.requestAnimationFrame(step);
        } else {
          if (cb) {
            return cb();
          }
        }
      }
      window.requestAnimationFrame(step);
    }

    function buildImage(options) {
      let { className, src, alt, aspectRatio } = options;
      const img = document.createElement("img");
      img.className = className;
      img.src =
        "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
      img.dataset.src = src
        .replace(".jpg", "_{width}x.jpg")
        .replace(".png", "_{width}x.png");
      img.dataset.sizes = "auto";
      img.dataset.aspectratio = aspectRatio;
      img.setAttribute("alt", alt);
      img.setAttribute("draggable", "false");
      return img;
    }

    function updateCustomerField(key, value, cb, saveCustomer = true) {
      try {
        CF.customerReady(function () {
          CF.customer.set(key, value);
          if (!saveCustomer) {
            return cb();
          }
          CF.customer
            .save()
            .then(function (errorObj) {
              if (errorObj) {
                console.log("Utils.updateCustomerField error: ", errorObj);
              }
              return errorObj
                ? cb(undefined, "Utils.updateCustomerField request has failed.")
                : cb();
            })
            .catch(function (err) {
              console.error("Error updating " + key, err);
              return cb(undefined, err);
            });
        });
      } catch (exception) {
        return cb(undefined, exception);
      }
    }

    function buildStar(isEmpty = false, num = 1) {
      const filledPath =
        "m3.2 16.0001081c-.1687782 0-.33328968-.0531313-.47-.1521081-.24051968-.174488-.36451194-.4679107-.322-.762l.743-5.203-2.917-2.917c-.21191095-.21196521-.28756133-.52460199-.196-.81.09130759-.2851682.3345701-.49522345.63-.544l4.398-.734 2.218-4.435c.13744692-.27145241.41573373-.4426761.72-.443.3045618.00166772.58175678.1761261.715.45l2.123 4.362 4.498.801c.2933158.05211246.5333796.26289081.623.547.0898959.28455453.0135125.59548872-.198.806l-2.917 2.917.744 5.203c.042199.2957461-.0839008.5903645-.327.764-.2421349.1739598-.5609835.1986349-.827.064l-4.382-2.22-4.502 2.223c-.10996656.0547452-.23116004.0831081-.354.0831081z";
      const emptyPath =
        "m3.2 16.0001081c-.1687782 0-.33328968-.0531313-.47-.1521081-.24051968-.174488-.36451194-.4679107-.322-.762l.743-5.203-2.917-2.917c-.21191095-.21196521-.28756133-.52460199-.196-.81.09130759-.2851682.3345701-.49522345.63-.544l4.398-.734 2.218-4.435c.13744692-.27145241.41573373-.4426761.72-.443.3045618.00166772.58175678.1761261.715.45l2.123 4.362 4.498.801c.2933158.05211246.5333796.26289081.623.547.0898959.28455453.0135125.59548872-.198.806l-2.917 2.917.744 5.203c.042199.2957461-.0839008.5903645-.327.764-.2421349.1739598-.5609835.1986349-.827.064l-4.382-2.22-4.502 2.223c-.10996656.0547452-.23116004.0831081-.354.0831081zm1.51-2.8841081 3.357-1.658.892.452 2.327 1.178-.56-3.912.708-.707 1.29-1.29-3.234-.576-.446-.915-1.06-2.176-1.584 3.171-1.005.168-2.098.35 1.975 1.975-.141.99z";
      const ns = "http://www.w3.org/2000/svg";
      const svg = document.createElementNS(ns, "svg");
      svg.classList.add("icon");
      svg.setAttribute("viewBox", "0 0 16 16");
      svg.setAttribute("role", "img");
      svg.setAttribute("width", "16");
      svg.setAttribute("height", "16");
      const path = document.createElementNS(ns, "path");
      path.setAttribute("d", isEmpty ? emptyPath : filledPath);
      path.setAttribute("fill", "var(--junipStarColor)");
      svg.appendChild(path);
      if (num === 1) {
        return svg;
      }
      const stars = document.createDocumentFragment();
      stars.appendChild(svg);
      let k = 1;
      while (k < num) {
        stars.appendChild(svg.cloneNode(true));
        k += 1;
      }
      return stars;
    }
    const getRecentlyViewedProductHandles = function () {
      const handles = [];
      const cookie = getCookie(PLUG.recentlyViewedCookieName);
      if (cookie) {
        const cookieValue = cookie.split("=")[1];
        handles.push(...cookieValue.split(","));
      }
      return handles;
    };

    function buildDiamond(isEmpty = false, num = 1) {
      if (num === 0) {
        return document.createDocumentFragment();
      }
      const filledDiamondColor = "#f1c62d";
      const emptyDiamondColor = "#c4c4c4";
      const ns = "http://www.w3.org/2000/svg";
      const svg = document.createElementNS(ns, "svg");
      svg.classList.add("icon", "diamond-icon");
      svg.setAttribute("aria-hidden", "true");
      svg.setAttribute("focusable", "false");
      svg.setAttribute("role", "presentation");
      svg.setAttribute("viewBox", "0 0 17 14");
      svg.setAttribute("width", "17");
      svg.setAttribute("height", "14");
      const path = document.createElementNS(ns, "path");
      path.setAttribute(
        "d",
        "M2.96212 0L0 3.22124H2.83333L4.50758 0H2.96212ZM5.2803 0L3.60606 3.22124H13.3939L11.7197 0H5.2803ZM12.4924 0L14.1667 3.22124H17L14.0379 0H12.4924ZM0 3.9646L6.95455 12.3894L2.83333 3.9646H0ZM3.60606 3.9646L8.5 14L13.3939 3.9646H3.60606ZM14.1667 3.9646L10.0455 12.3894L17 3.9646H14.1667Z"
      );
      path.setAttribute(
        "fill",
        isEmpty ? emptyDiamondColor : filledDiamondColor
      );
      svg.appendChild(path);
      if (num === 1) {
        return svg;
      }
      const docFrag = document.createDocumentFragment();
      docFrag.appendChild(svg);
      let k = 1;
      while (k < num) {
        docFrag.appendChild(svg.cloneNode(true));
        k += 1;
      }
      return docFrag;
    }

    function fillDiamondHalfway(diamondSvg, gradientId) {
      const svgns = "http://www.w3.org/2000/svg";
      const path = diamondSvg.getElementsByTagName("path")[0];
      const defs = document.createElementNS(svgns, "defs");
      const linearGradient = document.createElementNS(svgns, "linearGradient");
      const stop1 = document.createElementNS(svgns, "stop");
      const stop2 = document.createElementNS(svgns, "stop");
      path.setAttribute("fill", `url(#${gradientId})`);
      linearGradient.id = gradientId;
      stop1.setAttribute("offset", "50%");
      stop1.setAttribute("stop-color", "#f1c62d");
      stop2.setAttribute("offset", "50%");
      stop2.setAttribute("stop-opacity", "1");
      stop2.setAttribute("stop-color", "#ceced3");
      linearGradient.appendChild(stop1);
      linearGradient.appendChild(stop2);
      defs.appendChild(linearGradient);
      diamondSvg.insertBefore(defs, diamondSvg.children[0]);
    }
    Utils.export = function () {
      return Object.freeze({
        getUrlParam,
        setUrlParam,
        removeUrlParam,
        isMobile,
        waitUntilTrue,
        addClasses,
        removeClasses,
        extractElement,
        replaceElement,
        getCookie,
        setCookie,
        bindThisToAllMethods,
        filterArray,
        mapArray,
        forEach,
        find,
        fallback: Parseq.fallback,
        parallel: Parseq.parallel,
        parallelObject: Parseq.parallel_object,
        race: Parseq.race,
        sequence: Parseq.sequence,
        getWishlistProducts: Wishlist.getWishlistProducts,
        initWishlistButtons: Wishlist.initWishlistButtons,
        addProductToWishlist: Wishlist.addProductToWishlist,
        removeProductFromWishlist: Wishlist.removeProductFromWishlist,
        updateAllFavoriteButtons: Wishlist.updateAllFavoriteButtons,
        buildHeartIcon: Wishlist.buildHeartIcon,
        buildCardFavButton: Wishlist.buildCardFavButton,
        addListenerToFavButton: Wishlist.addListenerToFavButton,
        capitalize,
        camelCase,
        formatMoney,
        formatImageSource,
        formatImageSrcset,
        afterNextRepaint,
        removeChildren,
        setAttributes,
        setButtonLoadingState,
        convertDomNodeToString,
        listboxConstructor,
        stringToDomNode,
        smoothScrollTo,
        buildImage,
        throttlerConstructor,
        integer,
        element,
        makeXmlRequest,
        addItemToCart,
        addItemsToCart,
        getProduct,
        getFreshSection,
        refreshSection,
        submitForm,
        toDataUrl,
        updateCustomerField,
        buildStar,
        getRecentlyViewedProductHandles,
        buildDiamond,
        fillDiamondHalfway,
      });
    };
  })((PLUG.Utils = Object.create(null)));
  (function (Form) {
    "use strict";
    const selectors = {
      text: {
        field: ".text-field, .plug-cfields-text-field.cf-field",
        input: ".text-field-input, .plug-cfields-text-field input",
        label: ".text-field-label, .plug-cfields-text-field label",
      },
      select: {
        container: ".select-field-container, .cf-field-container",
        field: ".select-field, .plug-cfields-select-field.cf-field",
        select: ".select-field-select, select",
      },
    };

    function setupTextFields(form) {
      const textFields = Array.from(
        form.querySelectorAll(selectors.text.field)
      );
      const blurAllTextFields = function () {
        textFields.forEach(function (textField) {
          textField.classList.remove("is-focused");
        });
      };
      const focusTextField = function (textField) {
        blurAllTextFields();
        textField.classList.add("is-focused");
      };
      textFields.forEach(function (textField) {
        const input = textField.querySelector("input, textarea");
        const label = textField.getElementsByTagName("label")[0];
        input.addEventListener(
          "focus",
          function () {
            focusTextField(textField);
          },
          true
        );
        input.addEventListener("blur", blurAllTextFields, true);
        input.addEventListener("change", function () {
          if (input.value === "") {
            textField.classList.remove("is-not-empty");
          } else {
            textField.classList.add("is-not-empty");
          }
        });
        if (input.value !== "") {
          textField.classList.add("is-not-empty");
        }
        setTimeout(function () {
          const borderTopColor = window
            .getComputedStyle(input)
            .getPropertyValue("border-top-color");
          if (borderTopColor === "rgb(252, 252, 252)") {
            textField.classList.add("is-not-empty");
          }
          textField.classList.remove("is-loading");
          setTimeout(function () {
            label.classList.remove("is-instant-transition");
          }, 25);
        }, 50);
      });
    }

    function setupSelectFields(form) {
      const selectFields = Array.from(
        form.querySelectorAll(selectors.select.field)
      );
      const blurAllSelectFields = function () {
        selectFields.forEach(function (selectField) {
          selectField.classList.remove("is-focused");
        });
      };
      const focusSelectField = function (selectField) {
        blurAllSelectFields();
        selectField.classList.add("is-focused");
      };
      selectFields.forEach(function (selectField) {
        const select = selectField.querySelectorAll(selectors.select.select)[0];
        select.addEventListener(
          "focus",
          function () {
            focusSelectField(selectField);
          },
          true
        );
        select.addEventListener("blur", blurAllSelectFields, true);
        select.addEventListener("change", function () {
          if (select.value === "") {
            selectField.classList.remove("is-not-empty");
          } else {
            selectField.classList.add("is-not-empty");
          }
        });
        if (select.value !== "") {
          selectField.classList.add("is-not-empty");
        }
      });
    }

    function setupCheckboxFields(form) {
      Array.from(form.getElementsByClassName("plug-checkbox-field")).forEach(
        function (checkboxField) {
          const input = checkboxField.getElementsByClassName(
            "checkbox-field-checkbox"
          )[0];
          const icon = checkboxField.getElementsByClassName("checkbox-icon")[0];
          input.addEventListener("click", function () {
            if (input.checked) {
              icon.classList.add("checked");
            } else {
              icon.classList.remove("checked");
            }
          });
        }
      );
    }

    function setupCountryAndProvinceOptions(form) {
      const provinceSelect = form.querySelector("[data-state-select]");
      const countrySelect = form.querySelector("[data-country-select]");
      if (!provinceSelect || !countrySelect) {
        return;
      }

      function createProvinceOptions(countryOption) {
        let provinces = JSON.parse(
          countryOption.getAttribute("data-provinces")
        );
        provinces = provinces.map(function (subarray) {
          return subarray[1];
        });
        const provinceOptions = provinceSelect.getElementsByTagName("option");
        Array.from(provinceOptions).forEach(function (province, i) {
          if (i > 0) {
            province.parentElement.removeChild(province);
          }
        });
        const docFrag = document.createDocumentFragment();
        provinces.forEach(function (province) {
          const option = document.createElement("option");
          option.value = province;
          option.textContent = province;
          docFrag.appendChild(option);
        });
        const selectContainer = provinceSelect.closest(
          selectors.select.container
        );
        if (provinces.length) {
          selectContainer.classList.remove("is-hidden");
          provinceSelect.appendChild(docFrag);
        } else {
          selectContainer.classList.add("is-hidden");
        }
        const defaultProvince = provinceSelect.getAttribute("data-default");
        const optionExists = provinceSelect.querySelector(
          "option[value='" + defaultProvince + "']"
        );
        if (defaultProvince !== "" && optionExists) {
          provinceSelect.value = defaultProvince;
          provinceSelect.closest(".select-field").classList.add("is-not-empty");
        }
      }
      const defaultCountry = countrySelect.getAttribute("data-default");
      countrySelect.value = defaultCountry;
      const defaultOption = countrySelect.querySelector(
        "option[value='" + defaultCountry + "']"
      );
      countrySelect.addEventListener("change", function () {
        const country = countrySelect.value;
        const countryOption = countrySelect.querySelector(
          "option[value='" + country + "']"
        );
        createProvinceOptions(countryOption);
      });
      createProvinceOptions(defaultOption);
    }

    function init(form) {
      if (!form.classList.contains("is-initialized")) {
        form.classList.add("is-initialized");
        setupTextFields(form);
        setupSelectFields(form);
        setupCheckboxFields(form);
        setupCountryAndProvinceOptions(form);
      }
    }

    function initAll() {
      const formContainers = Array.from(
        document.getElementsByClassName("js-init-all-forms")
      );
      if (window.CF) {
        window.CF.ready(function () {
          formContainers.forEach(function (container) {
            const forms = Array.from(container.getElementsByTagName("form"));
            forms.forEach(init);
          });
        });
      } else {
        formContainers.forEach(function (container) {
          const forms = Array.from(
            container.getElementsByTagName("form")
          ).concat(Array.from(container.getElementsByClassName("js-form")));
          forms.forEach(init);
        });
      }
    }
    Form.export = function () {
      return Object.freeze({
        init,
        initAll,
      });
    };
  })((PLUG.Form = Object.create(null)));
  (function (Modal) {
    function init(modalEle, options = {}) {
      const backdrop = modalEle.getElementsByClassName("modal-backdrop")[0];
      const closeBtn = modalEle.getElementsByClassName("modal-close-btn")[0];
      let { onClose } = options;
      backdrop.addEventListener("click", close);
      if (closeBtn) {
        closeBtn.addEventListener("click", close);
      }

      function open() {
        modalEle.classList.remove("is-hidden");
        document.querySelector("html").classList.add("modal-is-open");
        window.requestAnimationFrame(function () {
          setTimeout(function () {
            modalEle.classList.add("is-open");
          }, 0);
        });
      }

      function close() {
        modalEle.classList.remove("is-open");
        document.querySelector("html").classList.remove("modal-is-open");
        setTimeout(function () {
          modalEle.classList.add("is-hidden");
        }, 300);
        if (onClose) {
          onClose();
        }
      }
      return Object.freeze({
        open,
        close,
      });
    }
    Modal.export = function () {
      return Object.freeze({
        init,
      });
    };
  })((PLUG.Modal = Object.create(null)));
  (function (ProductCardSlider) {
    let U;
    const defaultOptions = {
      cellAlign: "left",
      wrapAround: true,
      pageDots: false,
      arrowShape: {
        x0: 20,
        x1: 60,
        y1: 35,
        x2: 65,
        y2: 25,
        x3: 45,
      },
    };

    function init(sliderEle, options = {}, forceEqualCardHeights = false) {
      options = Object.assign(defaultOptions, options);
      let slider;
      let isMobile = U.isMobile();
      if (
        sliderEle.children.length > 4 ||
        (isMobile && sliderEle.children.length > 1)
      ) {
        initSlider();
      }
      let timer;
      PLUG.events.target.addEventListener("windowResize", function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          const wasMobile = isMobile;
          isMobile = U.isMobile();
          if (wasMobile && !isMobile) {
            if (
              slider &&
              sliderEle.querySelectorAll(".product-card").length <= 4
            ) {
              slider.destroy();
            }
          } else if (!wasMobile && isMobile) {
            if (
              !slider &&
              sliderEle.querySelectorAll(".product-card").length > 1
            ) {
              initSlider();
              return;
            }
          }
          if (forceEqualCardHeights) {
            U.afterNextRepaint(equalizeCardHeights);
          }
        }, 300);
      });

      function initSlider() {
        sliderEle.querySelectorAll(".product-card").forEach(function (card) {
          card.style.minHeight = "";
          card.querySelector(".product-card-title").style.minHeight = "";
        });
        U.afterNextRepaint(function () {
          slider = new Flickity(sliderEle, options);
          if (forceEqualCardHeights) {
            equalizeCardHeights();
          }
          U.updateAllFavoriteButtons();
        });
      }

      function equalizeCardHeights() {
        const cellElements = Array.from(
          sliderEle.querySelectorAll(".product-card")
        );
        const titles = Array.from(
          sliderEle.querySelectorAll(".product-card-title")
        );
        let k = 0;
        while (k < cellElements.length) {
          cellElements[k].style.minHeight = "";
          titles[k].style.minHeight = "";
          k += 1;
        }
        setTimeout(function () {
          equalizeElementHeights(titles);
          U.afterNextRepaint(function () {
            slider.resize();
            U.afterNextRepaint(function () {
              equalizeFlickitySlideHeights(slider);
              U.afterNextRepaint(function () {
                slider.resize();
              });
            });
          });
        }, 100);
      }
      return slider;
    }

    function equalizeFlickitySlideHeights(slider) {
      const maxHeight = findMaxCellHeight(slider);
      if (maxHeight > 0) {
        slider.cells.forEach(function (cell) {
          cell.element.style.minHeight = maxHeight.toString() + "px";
        });
      }
    }

    function equalizeElementHeights(elements) {
      const maxHeight = elements.reduce(function (max, element) {
        return Math.max(max, element.getBoundingClientRect().height);
      }, 0);
      if (maxHeight !== 0) {
        elements.forEach(function (element) {
          element.style.minHeight = maxHeight.toString() + "px";
        });
      }
    }

    function findMaxCellHeight(slider) {
      return slider.cells.reduce(function (max, cell) {
        return Math.max(max, cell.size.height);
      }, 0);
    }
    ProductCardSlider.export = function () {
      if (U === undefined) {
        U = PLUG.import("Utils");
      }
      return Object.freeze({
        init,
      });
    };
  })((PLUG.ProductCardSlider = Object.create(null)));
  (function (ProductCard) {
    let U;
    const isoCodeToPrefix = {
      HKD: "HK",
      CAD: "C",
      NZD: "NZ",
      SGD: "S",
      AUD: "A",
    };
    const tagDiscounts = {};
    const bfcmTagDiscounts = {
      "bf-10-off": {
        label: "10% Off",
        bfcmOnly: true,
        type: "percentage",
        value: 10,
      },
      "bf-15-off": {
        label: "15% Off",
        bfcmOnly: true,
        type: "percentage",
        value: 15,
      },
      "bf-25-off": {
        label: "25% Off",
        bfcmOnly: true,
        type: "percentage",
        value: 25,
      },
      "bf-35-off": {
        label: "35% Off",
        bfcmOnly: true,
        type: "percentage",
        value: 35,
      },
    };
    const isBfcm = PLUG.isBfcm;
    if (isBfcm) {
      Object.assign(tagDiscounts, bfcmTagDiscounts);
    }

    function build(productData, aggregateRating, options = {}) {
      const avgScore =
        aggregateRating.score || aggregateRating.averageRating || 0;
      const numReviews =
        aggregateRating.reviewCount || aggregateRating.numReviews || 0;
      const variant = productData.variants[0];
      const card = document.createElement("div");
      card.className = "product-card";
      card.dataset.productId = productData.id;
      card.dataset.variantId = productData.variants[0].id;
      const cardInner = document.createElement("a");
      cardInner.className = "product-card-inner";
      cardInner.href = `/products/${productData.handle}`;
      card.appendChild(cardInner);
      const favButton = U.buildCardFavButton(
        Number(productData.id),
        Number(variant.id),
        `https://pepetools.com/products/${productData.handle}`,
        productData.title,
        productData.images[0].includes("?")
          ? `${productData.images[0]}&width=180`
          : `${productData.images[0]}?width=180`
      );
      card.appendChild(favButton);
      const imgWrapper = document.createElement("div");
      imgWrapper.className = "product-card-img-wr";
      const ratioBox = document.createElement("div");
      ratioBox.className = "ratio-box ratio-box-square";
      const img = U.buildImage({
        className: "ratio-img lazyload full-width",
        src: productData.images[0],
        aspectRatio: 1,
      });
      imgWrapper.appendChild(ratioBox);
      ratioBox.appendChild(img);
      cardInner.appendChild(imgWrapper);
      const topMeta = document.createElement("div");
      topMeta.className = "product-card-top-meta";
      cardInner.appendChild(topMeta);
      const title = document.createElement("p");
      title.className = "product-card-title";
      title.textContent = productData.title;
      topMeta.appendChild(title);
      const score = document.createElement("p");
      score.className = "product-card-score";
      if (numReviews === 0) {
        score.style.opacity = "0";
      }
      let k = 1;
      while (k <= 5) {
        const diamond = U.buildStar(k > Math.ceil(Number(avgScore)));
        score.appendChild(diamond);
        k += 1;
      }
      const reviewCount = document.createElement("span");
      reviewCount.className = "product-card-review-count";
      reviewCount.textContent = `(${numReviews})`;
      score.appendChild(reviewCount);
      topMeta.appendChild(score);
      const sku = document.createElement("p");
      sku.className = "product-card-sku";
      sku.textContent = "SKU# " + variant.sku;
      topMeta.appendChild(sku);
      if (
        productData.tags
          .map((tag) => tag.toLowerCase())
          .includes("limited-stock")
      ) {
        const limitedStock = document.createElement("p");
        limitedStock.className = "product-limited-stock";
        limitedStock.textContent = "Limited Stock";
        topMeta.appendChild(limitedStock);
      }
      const price = computePrice(variant.price, productData.tags);
      const compareAtPrice = computeCompareAtPrice(
        variant.price,
        variant.compare_at_price,
        productData.tags
      );
      const priceRow = buildPriceRow(
        productData.available,
        price,
        compareAtPrice,
        productData.tags,
        options,
        productData.availablequantity
      );
      cardInner.appendChild(priceRow);
      buildBadge(productData.tags, card);
      return card;
    }

    function buildBadge(productTags, card) {
      const discountTag = productTags.find(
        (tag) => tag.toLowerCase() in tagDiscounts
      );
      if (discountTag) {
        const discount = tagDiscounts[discountTag.toLowerCase()];
        const badgeClassName =
          "product-card-badge" + (isBfcm ? " product-card-badge--bfcm" : "");
        if (card) {
          const badge = document.createElement("span");
          badge.className = badgeClassName;
          badge.textContent = discount.label;
          const cardInner = card.querySelector(".product-card-inner");
          const topMeta = card.querySelector(".product-detail-with-btn-prc");
          if (cardInner) {
            if (topMeta && cardInner.contains(topMeta)) {
              cardInner.insertBefore(badge, topMeta);
            } else {
              cardInner.prepend(badge); // fallback — adds badge at the top
            }
          }
        } else {
          return `<span class="${badgeClassName}">${discount.label}</span>`;
        }
      } else if (!card) {
        return "";
      }
    }

    function buildPriceRow(
      available,
      price,
      compareAtPrice,
      productTags = [],
      options = {},
      availablequantity
    ) {
      const priceRow = document.createElement("p");
      priceRow.className = "product-card-price-row";
      if (!available && availablequantity == 0) {
        const soldOutLabel = document.createElement("span");
        soldOutLabel.className = "product-card-sold-out-label";
        soldOutLabel.textContent = "Sold Out";
        priceRow.appendChild(soldOutLabel);
        return priceRow;
      }
      const priceEle = buildPriceEle(price, compareAtPrice, options);
      const compareAtPriceEle = buildCompareAtPriceEle(
        price,
        compareAtPrice,
        false,
        productTags
      );
      const savingsEle = buildSavingsEle(
        price,
        compareAtPrice,
        false,
        productTags
      );
      priceRow.appendChild(compareAtPriceEle);
      priceRow.appendChild(priceEle);
      priceRow.appendChild(savingsEle);
      return priceRow;
    }

    function buildPriceEle(price, compareAtPrice, options) {
      const priceString = computePriceLabel(price, compareAtPrice);
      const priceEle = document.createElement("span");
      priceEle.className = "product-card-price";
      priceEle.textContent = priceString;
      if (options.chainLengthFt) {
        const chainPriceLabel = ` (${U.formatMoney(
          price / options.chainLengthFt
        )}/ft.)`;
        const unitEle = document.createElement("span");
        unitEle.textContent = chainPriceLabel;
        unitEle.className = "product-card-price__unit";
        priceEle.appendChild(unitEle);
      }
      return priceEle;
    }

    function computePriceLabel(price, compareAtPrice, productTags = []) {
      let priceMoney = U.formatMoney(price);
      return compareAtPrice && compareAtPrice > price
        ? "Sale " + priceMoney
        : priceMoney;
    }

    function buildCompareAtPriceEle(price, compareAtPrice, returnHtmlString) {
      const wrapperClass = "product-card-compare-at-price";
      const compareAtPriceString = computeCompareAtPriceLabel(
        price,
        compareAtPrice
      );
      if (returnHtmlString) {
        return compareAtPrice && compareAtPrice > price
          ? '<span class="' +
              wrapperClass +
              '">' +
              compareAtPriceString +
              "</span>"
          : '<span class="' + wrapperClass + ' is-translucent"></span>';
      }
      const wrapper = document.createElement("span");
      wrapper.className = wrapperClass;
      wrapper.textContent = compareAtPriceString;
      return wrapper;
    }

    function computeCompareAtPriceLabel(price, compareAtPrice) {
      let compareAtPriceMoney;
      if (compareAtPrice && compareAtPrice > price) {
        compareAtPriceMoney = U.formatMoney(compareAtPrice);
        compareAtPriceMoney = "Reg. " + compareAtPriceMoney;
      }
      return compareAtPriceMoney ? compareAtPriceMoney : "";
    }

    function buildSavingsEle(price, compareAtPrice, returnHtmlString) {
      const wrapperClass = "product-card-price-savings";
      const savingsString = computeSavingsLabel(price, compareAtPrice);
      if (returnHtmlString) {
        return compareAtPrice && compareAtPrice > price
          ? '<span class="' + wrapperClass + '">' + savingsString + "</span>"
          : '<span class="' + wrapperClass + ' is-translucent"></span>';
      }
      const wrapper = document.createElement("span");
      wrapper.className = wrapperClass;
      wrapper.textContent = savingsString;
      return wrapper;
    }

    function computeSavingsLabel(price, compareAtPrice) {
      let savingsMoney;
      if (compareAtPrice && compareAtPrice > price) {
        savingsMoney = U.formatMoney(compareAtPrice - price);
        savingsMoney = "Save: " + savingsMoney;
      }
      return savingsMoney ? savingsMoney : "";
    }

    function computePrice(price, productTags = []) {
      const discountTag = productTags.find(
        (tag) => tag.toLowerCase() in tagDiscounts
      );
      if (!discountTag) {
        return price;
      } else {
        const discount = tagDiscounts[discountTag.toLowerCase()];
        return discount.type === "percentage"
          ? Math.round(price - price * (discount.value / 100))
          : Math.round(price - discount.value);
      }
    }

    function computeCompareAtPrice(price, compareAtPrice, productTags = []) {
      const discountTag = productTags.find(
        (tag) => tag.toLowerCase() in tagDiscounts
      );
      return !discountTag ? compareAtPrice : price;
    }
    ProductCard.export = function () {
      if (!U) {
        U = PLUG.import("Utils");
      }
      return Object.freeze({
        build,
        buildBadge,
        buildPriceRow,
        buildPriceEle,
        buildCompareAtPriceEle,
        buildSavingsEle,
        computePrice,
        computeCompareAtPrice,
        isBfcm,
        tagDiscounts,
      });
    };
  })((PLUG.ProductCard = Object.create(null)));
  (function (QuantityInput) {
    function init(wrapper, onChange = function () {}) {
      let increaseBtn;
      let decreaseBtn;
      let input;
      (function () {
        increaseBtn = wrapper.getElementsByClassName(
          "qty-input-btn qty-plus"
        )[0];
        decreaseBtn = wrapper.getElementsByClassName(
          "qty-input-btn qty-minus"
        )[0];
        input = wrapper.getElementsByClassName("qty-input")[0];
        increaseBtn.addEventListener("click", function () {
          const currentQuantity = getQuantity();
          const max = input.dataset.max;
          if (
            max === undefined ||
            max === "" ||
            currentQuantity < Number(max)
          ) {
            setQuantity(currentQuantity + 1);
          } else {
            console.log("maxed out");
          }
        });
        decreaseBtn.addEventListener("click", function () {
          const currentQuantity = getQuantity();
          if (currentQuantity > 1) {
            setQuantity(currentQuantity - 1);
          } else {
            console.log("Cannot decrease quantity below 1.");
          }
        });
        input.addEventListener("change", function () {
          const newQuantity = getQuantity();
          const max = input.dataset.max;
          setQuantity(
            max && max !== "" && newQuantity > Number(max)
              ? max
              : newQuantity < 1
              ? 1
              : newQuantity
          );
        });
      })();

      function getQuantity() {
        return Number(input.value);
      }

      function setQuantity(num) {
        if (
          input.max !== undefined &&
          input.max !== "" &&
          Number(input.max) < num
        ) {
          num = Math.max(1, Number(input.max));
        }
        input.value = num;
        return onChange(num);
      }

      function setMax(max) {
        if (max === false) {
          input.removeAttribute("max");
        } else {
          input.max = max;
        }
      }
      return Object.freeze({
        getQuantity,
        setQuantity,
        setMax,
      });
    }
    QuantityInput.export = function () {
      return Object.freeze({
        init,
      });
    };
  })((PLUG.QuantityInput = Object.create(null)));
  (function (Video) {
    let U;
    let numYtPlayersInitialized = 0;
    let ytIframeApiScript;
    let ytIframeApiScriptIsReady = false;
    const deferredYtPlayerInitOptions = [];
    window.onYouTubeIframeAPIReady = function () {
      console.log("heard yt api ready");
      ytIframeApiScriptIsReady = true;
      deferredYtPlayerInitOptions.forEach(function (args) {
        initYtPlayer(...args);
      });
    };
    Video.export = function () {
      U = U || PLUG.import("Utils");
      return Object.freeze({
        init,
        initYtPlayer,
      });
    };

    function init(videoEle) {
      const container = videoEle.parentElement;
      const previewImg =
        container.getElementsByClassName("video-preview-img")[0];
      const playButton = container.getElementsByClassName("btn-play-video")[0];
      playButton.addEventListener("click", play);

      function play() {
        U.setButtonLoadingState(playButton, true);
        loadVideo(function (err) {
          U.setButtonLoadingState(playButton, false);
          if (err) {
            console.log("Failed to load video: ", err);
            return;
          }
          previewImg.classList.add("is-hidden");
          videoEle.classList.remove("is-hidden");
          playButton.classList.add("is-hidden");
          previewImg.classList.add("is-hidden");
          videoEle.classList.remove("is-hidden");
        });
      }

      function loadVideo(cb) {
        if (videoEle.classList.contains("is-loaded")) {
          return cb();
        }
        const sources = JSON.parse(videoEle.dataset.srcs);
        sources.forEach(function (source) {
          const sourceEle = document.createElement("source");
          sourceEle.src = source.src;
          sourceEle.type = source.type;
          videoEle.appendChild(sourceEle);
        });
        U.waitUntilTrue(
          function videoReadyToPlay() {
            return videoEle.readyState === 4;
          },
          cb,
          50,
          100
        );
      }
      return Object.freeze({
        play,
      });
    }

    function initYtPlayer(options, cb) {
      let { iframe, onReady } = options;
      if (!ytIframeApiScriptIsReady) {
        deferredYtPlayerInitOptions.push([options, cb]);
        if (!ytIframeApiScript) {
          ytIframeApiScript = document.createElement("script");
          ytIframeApiScript.id = "youtube-iframe-api-script";
          ytIframeApiScript.src = "https://www.youtube.com/iframe_api";
          const firstScriptTag = document.getElementsByTagName("script")[0];
          firstScriptTag.parentNode.insertBefore(
            ytIframeApiScript,
            firstScriptTag
          );
        }
      } else {
        iframe.id =
          iframe.id === "" ? "yt-iframe-" + numYtPlayersInitialized : iframe.id;
        numYtPlayersInitialized += 1;
        return cb(
          new YT.Player(iframe.id, {
            events: {
              onReady,
            },
          })
        );
      }
    }
  })((PLUG.Video = Object.create(null)));
  (function (Frame) {
    "use strict";
    let U;
    let Modal;
    let QuantityInput;
    let header;
    let nav;
    let siteDrawerLeft;
    let siteDrawerRight;
    let siteOverlay;
    let cart;
    let alertModal;
    let fintechModal;
    let mobileNavMenu;
    Frame.init = function () {
      U = PLUG.import("Utils");
      QuantityInput = PLUG.import("QuantityInput");
      Modal = PLUG.import("Modal");
      PLUG.events.leftDrawerClose = new Event("leftDrawerClose");
      PLUG.events.rightDrawerClose = new Event("rightDrawerClose");
      header = document.getElementById("shopify-section-header");
      nav = document.getElementById("site-nav");
      siteDrawerLeft = document.getElementById("site-drawer-left");
      siteDrawerRight = document.getElementById("site-drawer-right");
      siteOverlay = document.getElementById("site-overlay");
      const upsellsSection =
        PLUG.template === "cart"
          ? document.getElementById("cart-page-main")
          : document.getElementById("cart-menu");
      const upsells = upsellsSection ? CartUpsells(upsellsSection) : null;
      const rightDrawer = Drawer("right");
      cart = Cart(rightDrawer, upsells);
      const leftDrawer = Drawer("left");
      mobileNavMenu = MobileNavMenu(leftDrawer);
      if (siteOverlay) {
        siteOverlay.addEventListener("click", function () {
          rightDrawer.close();
          leftDrawer.close();
        });
      }
      const searchbar = Searchbar();
      DesktopNavMenus();
      CurrencySelector();
      CountrySelectorForm();
      Subscribe();
      alertModal = AlertModal();
      fintechModal = FintechModal();
      Frame.export = function () {
        return Object.freeze({
          cart,
          alertModal,
          searchbar,
          upsells,
        });
      };
    };

    function Searchbar() {
      const searchBtn = document.getElementById("site-nav-toggle-search");
      const searchBar = document.getElementById("site-searchbar");
      const input = document.getElementById("plug-site-search");
      const snizeDesktopBreakpoint = 821;
      const snizeMode =
        window.innerWidth < snizeDesktopBreakpoint ? "fullPage" : "dropdown";
      const mobileClass = "snize-custom-widget-opener";
      if (snizeMode === "fullPage") {
        initFullPageSearch();
      } else {
        initDropdownSearch();
      }

      function initFullPageSearch() {
        searchBtn.classList.add(mobileClass);
      }

      function initDropdownSearch() {
        searchBtn.addEventListener("click", function () {
          toggle();
        });

        function open() {
          console.log("Open searchbar");
          nav.dataset.searchbarState = "expanded";
          input.focus();
          window.requestAnimationFrame(function () {
            setTimeout(function () {
              searchBar.classList.add("is-active");
            }, 0);
          });
        }

        function close() {
          console.log("Close searchbar");
          searchBar.classList.remove("is-active");
          nav.dataset.searchbarState = "collapsed";
          if (searchBar.classList.contains("plug-snize-mobile")) {
            const snizeCloseButton = document.querySelector(
              ".snize-ac-results .snize-close-button"
            );
            if (snizeCloseButton) {
              setTimeout(() => {
                snizeCloseButton.click();
              }, 0);
            }
          }
        }

        function isOpen() {
          return nav.dataset.searchbarState === "expanded";
        }

        function toggle() {
          return isOpen() ? close() : open();
        }
      }
      return Object.freeze({});
    }

    function Drawer(side) {
      const drawerEle = side === "left" ? siteDrawerLeft : siteDrawerRight;
      if (!drawerEle) {
        return;
      }
      const drawerMenus = Array.from(
        drawerEle.getElementsByClassName("site-drawer-menu")
      );

      function hideMenus() {
        drawerMenus.forEach(function (menu) {
          menu.classList.add("is-hidden");
        });
      }

      function open(menu) {
        document.body.classList.add("is-unscrollable", "drawer-is-open");
        hideMenus();
        drawerEle.classList.remove("is-hidden");
        menu.classList.remove("is-hidden");
        siteOverlay.classList.remove("is-hidden");
        if (window.innerWidth < 425) {
          header.style.background = "#fff";
        }
        setTimeout(function () {
          drawerEle.classList.add("is-open");
          siteOverlay.classList.add("is-active");
        }, 25);
      }

      function close() {
        if (!drawerEle.classList.contains("is-open")) {
          return;
        }
        document.body.classList.remove("is-unscrollable", "drawer-is-open");
        drawerEle.classList.remove("is-open");
        siteOverlay.classList.remove("is-active");
        PLUG.events.target.dispatchEvent(PLUG.events[side + "DrawerClose"]);
        header.style.background = "";
        siteOverlay.classList.add("is-hidden");
        setTimeout(function () {
          drawerEle.classList.add("is-hidden");
          hideMenus();
        }, 300);
      }

      function isOpen() {
        return drawerEle.classList.contains("is-open");
      }
      return Object.freeze({
        open,
        close,
        isOpen,
        toggle: function (menu) {
          return isOpen() ? close() : open(menu);
        },
      });
    }

    function CartUpsells(container) {
      const routeRoot =
        window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : "/";
      const defaultPostHeaders = {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      };
      const sectionId = container.dataset.sectionId;
      const productIdToComplementaryProducts = {};
      const useAddonMetafieldsAsFallback =
        container.dataset.useAddonsAsFallback === "true";
      const addToCartSubscribers = [];

      function init() {
        const productIds = Array.from(
          container.querySelectorAll("[data-cart-item]")
        )
          .reverse()
          .reduce((ids, item) => {
            const productId = item.dataset.productId;
            if (!ids.includes(productId)) {
              ids.push(productId);
            }
            return ids;
          }, []);
        fetchAllComplementaryProducts(productIds).then(() =>
          buildUpsells(productIds)
        );
      }

      function fetchAllComplementaryProducts(productIds) {
        const nonCachedProductIds = productIds.reduce(
          (nonCached, productId) => {
            if (
              !Object.keys(productIdToComplementaryProducts).includes(productId)
            ) {
              nonCached.push(productId);
            }
            return nonCached;
          },
          []
        );
        const promises = nonCachedProductIds.map((id) =>
          fetchComplementaryProducts(id)
        );
        return Promise.allSettled(promises).then((results) => {
          results.forEach((result, index) => {
            if (result.status === "fulfilled") {
              productIdToComplementaryProducts[nonCachedProductIds[index]] =
                result.value;
            } else {
              console.error(result.reason);
            }
          });
        });
      }

      function fetchComplementaryProducts(productId) {
        return new Promise((resolve) => {
          fetch(
            `${location.origin}${routeRoot}recommendations/products.json?limit=5&intent=complementary&product_id=${productId}`
          )
            .then((response) => response.json())
            .then((data) => {
              resolve(data.products);
            })
            .catch((exception) => {
              console.error(exception);
              resolve([]);
            });
        });
      }

      function buildUpsells(productIds) {
        const upsellProducts = computeUpsellProducts(productIds);
        const list = container.querySelector("[data-cart-upsells-list]");
        if (!list) {
          return;
        }
        while (list.children.length) {
          list.removeChild(list.children[0]);
        }
        if (upsellProducts.length) {
          container
            .querySelector("[data-cart-upsells]")
            .classList.remove("is-hidden");
          const elements = upsellProducts.map(buildUpsellItem);
          const docFrag = document.createDocumentFragment();
          elements.forEach((ele) => docFrag.appendChild(ele));
          list.appendChild(docFrag);
          elements.forEach((element, index) =>
            initUpsellItemListeners(element, upsellProducts[index])
          );
        } else {
          container
            .querySelector("[data-cart-upsells]")
            .classList.add("is-hidden");
        }
      }

      function initUpsellItemListeners(item, product) {
        const select = item.querySelector(".cart-upsell-item__variant-select");
        const addButton = item.querySelector(".cart-upsell-item__add-button");
        select.addEventListener("change", () => {
          const selectedOption = select.selectedOptions[0];
          const selectedVariantId = selectedOption.dataset.value;
          const selectedVariant = product.variants.find(
            (variant) => String(variant.id) === selectedVariantId
          );
          updateUpsellItemSelectedVariant(item, product, selectedVariant);
        });
        addButton.addEventListener("click", () => {
          const variantId = addButton.dataset.variantId;
          U.setButtonLoadingState(addButton, true);
          updateCart(
            {
              [Number(variantId)]: 1,
            },
            [sectionId]
          )
            .then((data) => {
              const newCartMenu = data.sections[sectionId];
              const section = U.stringToDomNode(newCartMenu);
              addToCartSubscribers.forEach((sub) => {
                sub(undefined, section);
              });
            })
            .finally(() => {
              if (addButton) {
                U.setButtonLoadingState(addButton, false);
              }
            });
        });
      }

      function onAddToCart(subscriber) {
        addToCartSubscribers.push(subscriber);
      }

      function computeUpsellProducts(productIds) {
        const upsellProducts = [];
        let k = 0;
        while (k < productIds.length) {
          const productId = productIds[k];
          const complementaryProducts =
            productIdToComplementaryProducts[productId];
          if (complementaryProducts.length) {
            upsellProducts.push(
              ...complementaryProducts.filter(
                (p) =>
                  p.available &&
                  !productIds.includes(String(p.id)) &&
                  !upsellProducts.some((up) => String(up.id) === String(p.id))
              )
            );
          }
          if (upsellProducts.length >= 3) {
            break;
          }
          k += 1;
        }
        if (useAddonMetafieldsAsFallback && upsellProducts.length < 3) {
          const script = document.getElementById(
            "data--cart-item-addon-products"
          );
          const { cartItems } = JSON.parse(script.innerHTML);
          cartItems.reverse();
          let n = 0;
          while (n < cartItems.length) {
            const cartItem = cartItems[n];
            if (cartItem.addonProducts.length) {
              upsellProducts.push(
                ...cartItem.addonProducts.filter(
                  (p) =>
                    p.available &&
                    !productIds.includes(String(p.id)) &&
                    !upsellProducts.some((up) => String(up.id) === String(p.id))
                )
              );
            }
            if (upsellProducts.length >= 3) {
              break;
            }
            n += 1;
          }
        }
        return upsellProducts.slice(0, 3);
      }

      function updateUpsellItemSelectedVariant(item, product, variant) {
        setItemPrice(item, variant);
        setItemImage(item, product, variant);
        item.querySelector(".cart-upsell-item__add-button").dataset.variantId =
          variant.id;
      }

      function buildUpsellItem(product) {
        const item = document
          .getElementById("template--cart-upsell-item")
          .content.children[0].cloneNode(true);
        const variant = product.variants.find((variant) => variant.available);
        item.dataset.productId = product.id;
        const links = item.querySelectorAll("a");
        links.forEach((link) => {
          link.href = product.url;
        });
        const title = item.querySelector(".cart-upsell-item__title");
        title.textContent = product.title;
        setItemPrice(item, variant);
        setItemImage(item, product, variant);
        const select = item.querySelector(".cart-upsell-item__variant-select");
        const availableVariants = product.variants.filter((v) => v.available);
        if (availableVariants.length > 1) {
          availableVariants.forEach((variant) => {
            const option = document.createElement("option");
            option.textContent = variant.title;
            option.dataset.value = variant.id;
            select.appendChild(option);
          });
          select.value = variant.title;
        } else {
          select.parentElement.classList.add("is-hidden");
        }
        item.querySelector(".cart-upsell-item__add-button").dataset.variantId =
          variant.id;
        return item;
      }

      function setItemPrice(item, variant) {
        item.querySelector(".price").textContent = U.formatMoney(
          variant.price,
          true
        );
      }

      function setItemImage(item, product, variant) {
        const img = item.querySelector("img");
        let src = variant.featured_image
          ? variant.featured_image.src
          : product.images[0];
        if (src.includes(".png")) {
          src = src.replace(".png", "_240x.png");
        } else if (src.includes(".jpg")) {
          src = src.replace(".jpg", "_240x.jpg");
        }
        img.src = src;
        img.alt = `${product.title}${
          product.variants.length ? ` - ${variant.title}` : ""
        }`;
      }

      function updateCart(updates, sections, sectionsUrl, headers) {
        const body = {
          updates,
        };
        if (sections) {
          body.sections = sections;
        }
        if (sectionsUrl) {
          body.sections_url = sectionsUrl;
        }
        const requestOptions = {
          method: "POST",
          headers: Object.assign(defaultPostHeaders, headers),
          body: JSON.stringify(body),
        };
        return fetch(`${routeRoot}cart/update.js`, requestOptions)
          .then((data) => data.json())
          .then((data) => {
            if (data.message === "Cart Error") {
              console.error(data);
              throw new Error(data.description);
            }
            return data;
          });
      }
      return Object.freeze({
        init,
        onAddToCart,
      });
    }

    function Cart(drawer, upsells) {
      const menu = document.getElementById("cart-menu");
      if (!menu) {
        return;
      }
      const openBtn = document.getElementById("site-nav-toggle-cart");
      const closeBtn = document.getElementById("close-cart-menu-btn");
      const events = {
        open: new Event("open"),
        close: new Event("close"),
        refresh: new Event("refresh"),
      };
      (function init() {
        if (PLUG.template !== "cart") {
          openBtn.addEventListener("click", function () {
            if (drawer.isOpen()) {
              close();
            } else {
              open();
            }
          });
          closeBtn.addEventListener("click", close);
          setupItemListeners();
          upsells.onAddToCart(refresh);
          upsells.init();
        }
      })();

      function open() {
        mobileNavMenu.close();
        document.body.classList.add("cart-is-showing");
        openBtn.classList.add("is-active");
        menu.dispatchEvent(events.open);
        return drawer.open(menu);
      }

      function close() {
        document.body.classList.remove("cart-is-showing");
        openBtn.classList.remove("is-active");
        menu.dispatchEvent(events.close);
        return drawer.close(menu);
      }

      function getJson(cb) {
        U.makeXmlRequest(
          {
            method: "GET",
            url: "/cart.js",
          },
          cb
        );
      }

      function changeItem(key, qty, cb) {
        return U.makeXmlRequest(
          {
            method: "POST",
            url: "/cart/change.js",
            requestBody: JSON.stringify({
              quantity: qty,
              id: key,
            }),
          },
          cb
        );
      }

      function refresh(cb, section) {
        const replaceSection = function (section) {
          const newCartMenuTitle = section.querySelector(".cart-menu-title");
          const cartMenuTitle = document.querySelector(".cart-menu-title");
          cartMenuTitle.dataset.visibleItemCount =
            newCartMenuTitle.dataset.visibleItemCount;
          cartMenuTitle.textContent = newCartMenuTitle.textContent;
          const cartMenuMain = section.querySelector(".cart-menu-main");
          const oldCartMenuMain = document.querySelector(".cart-menu-main");
          const parent = oldCartMenuMain.parentElement;
          parent.removeChild(oldCartMenuMain);
          parent.appendChild(cartMenuMain);
          const oldAddonDataScript = document.getElementById(
            "data--cart-item-addon-products"
          );
          const newAddonDataScript = section.querySelector(
            "#data--cart-item-addon-products"
          );
          U.replaceElement(oldAddonDataScript, newAddonDataScript);
          setupItemListeners();
          if (U.updateCartCount) {
            U.updateCartCount();
          }
          upsells.init();
          U.afterNextRepaint(function () {
            menu.dispatchEvent(events.refresh);
          });
          if (cb) {
            return cb();
          }
        };
        if (!section) {
          U.getFreshSection("cart-menu", (section, reason) => {
            if (reason) {
              if (cb) {
                return cb(undefined, reason);
              } else {
                console.log(reason);
                return;
              }
            }
            return replaceSection(section);
          });
        } else {
          return replaceSection(section);
        }
      }

      function setupItemListeners() {
        U.forEach(
          menu.getElementsByClassName("cart-menu-item"),
          function setupItem(item) {
            const key = item.dataset.key;
            QuantityInput.init(
              item.getElementsByClassName("qty-input-wrapper")[0],
              function onChange(num) {
                updateItemQuantity(key, num);
              }
            );
            const deleteBtn = item.getElementsByClassName(
              "cart-menu-item-remove-btn"
            )[0];
            deleteBtn.addEventListener("click", function () {
              updateItemQuantity(key, 0);
            });
          }
        );
      }

      function updateItemQuantity(key, newQty) {
        return changeItem(key, newQty, function (data, reason) {
          if (reason) throw reason;
          return refresh(function (data, reason) {
            if (reason) throw reason;
          });
        });
      }
      return Object.freeze({
        open,
        close,
        getJson,
        refresh,
        changeItem,
      });
    }

    function MobileNavMenu(drawer) {
      const menu = document.getElementById("mobile-nav");
      if (!menu) {
        return;
      }
      const toggleBtn = document.getElementById("site-nav-mobile-menu-btn");
      const closeBtn = document.getElementsByClassName("mobile-nav-close")[0];
      const parentList = document.getElementById(
        "mobile-nav-parent-collections"
      );
      const childLists = document.getElementsByClassName(
        "mobile-nav-linklist child-linklist"
      );
      const mobileMenuBtns = document.getElementsByClassName("mobile-nav-btn");
      let activeList = parentList;
      U.forEach(mobileMenuBtns, function setup(btn) {
        btn.addEventListener("click", function () {
          if (Number(btn.dataset.goToLevel) === 1) {
            const childList = activeList;
            activeList = childList;
            childList.classList.remove("slide-into-view");
            parentList.classList.remove("slide-out-of-view");
            setTimeout(function () {
              childList.classList.add("is-hidden");
            }, 300);
          } else {
            U.addClasses(childLists, "is-hidden");
            const childHandle = btn.dataset.childHandle;
            const childList = U.find(childLists, function (list) {
              return list.dataset.listHandle === childHandle;
            });
            if (childList && childList.getElementsByTagName("li").length > 1) {
              activeList = childList;
              childList.classList.remove("is-hidden");
              U.afterNextRepaint(function () {
                childList.classList.add("slide-into-view");
                parentList.classList.add("slide-out-of-view");
              });
            } else {
              window.location.href = btn.dataset.url;
            }
          }
        });
      });

      function open() {
        cart.close();
        toggleBtn.classList.add("is-selected");
        closeBtn.classList.remove("is-hidden");
        return drawer.open(menu);
      }

      function close() {
        toggleBtn.classList.remove("is-selected");
        closeBtn.classList.add("is-hidden");
        return drawer.close();
      }
      closeBtn.addEventListener("click", close);
      toggleBtn.addEventListener("click", function () {
        return toggleBtn.classList.contains("is-selected") ? close() : open();
      });
      PLUG.events.target.addEventListener("leftDrawerClose", function () {
        toggleBtn.classList.remove("is-selected");
      });
      return Object.freeze({
        open,
        close,
      });
    }

    function DesktopNavMenus() {
      const primaryLinkElements = document.getElementsByClassName(
        "site-nav-bottom-link"
      );
      const primaryLinks = U.mapArray(primaryLinkElements, menuLinkConstructor);

      function menuLinkConstructor(link) {
        const linkWrapper = link.parentElement;
        const menu = linkWrapper.getElementsByClassName("l2-nav-menu")[0];
        const menuContent =
          linkWrapper.getElementsByClassName("l2-nav-menu-inner")[0];
        const hasVideo = menu && menu.classList.contains("has-video");
        let videoInitialized;

        function open() {
          if (link.classList.contains("is-active")) {
            return;
          }
          closeAll();
          if (menu) {
            if (hasVideo && !videoInitialized) {
              videoInitialized = true;
              const video = menu.getElementsByTagName("video")[0];
              const videoPreviewImage =
                menu.getElementsByClassName("video-preview-img")[0];
              lazySizes.loader.unveil(videoPreviewImage);
              const source = document.createElement("source");
              source.type = "video/mp4";
              source.src = video.getAttribute("data-src");
              video.appendChild(source);
              let ignore;
              video.addEventListener("loadeddata", function () {
                if (!ignore && video.readyState >= 2) {
                  ignore = true;
                  videoPreviewImage.classList.add("is-hidden");
                  video.classList.remove("is-hidden");
                  video.play();
                }
              });
            } else if (hasVideo) {
              const video = menu.getElementsByTagName("video")[0];
              video.play();
            }
            menu.classList.remove("is-hidden");
            nav.classList.add("desktop-nav-menu-is-open");
            U.afterNextRepaint(function () {
              menuContent.classList.remove("is-translucent");
              link.classList.add("is-active");
            });
          } else {
            link.classList.add("is-active");
          }
        }

        function close() {
          link.classList.remove("is-active");
          if (menu) {
            if (hasVideo) {
              const video = menu.getElementsByTagName("video")[0];
              video.pause();
            }
            menuContent.classList.add("is-translucent");
            menu.classList.add("is-hidden");
            nav.classList.remove("desktop-nav-menu-is-open");
          }
        }
        let openTimer;
        let closeTimer;
        link.addEventListener(
          "mouseenter",
          function () {
            clearTimeout(openTimer);
            clearTimeout(closeTimer);
            openTimer = setTimeout(open, 100);
          },
          false
        );
        link.addEventListener("mouseleave", function () {
          clearTimeout(closeTimer);
          clearTimeout(openTimer);
          closeTimer = setTimeout(close, 100);
        });
        if (menu) {
          menu.addEventListener("mouseenter", function () {
            clearTimeout(closeTimer);
          });
          menu.addEventListener("mouseleave", function () {
            clearTimeout(closeTimer);
            closeTimer = setTimeout(close, 100);
          });
        }
        return Object.freeze({
          close,
        });
      }

      function closeAll() {
        primaryLinks.forEach(function (link) {
          link.close();
        });
      }
    }

    function CurrencySelector() {
      let form;
      let desktopListboxEle;
      let mobileListboxEle;
      let hiddenCurrencyInput;
      (function init() {
        try {
          form = document.getElementById("top-bar-currency-selector");
          if (!form) {
            return;
          }
          desktopListboxEle = document.getElementsByClassName(
            "currency-selector listbox"
          )[0];
          mobileListboxEle = document.getElementsByClassName(
            "mobile-currency-selector"
          )[0];
          hiddenCurrencyInput = form.querySelector(
            "input[name='country_code']"
          );
          setupListboxes();
        } catch (exception) {
          console.log("Error setting up currency selector.", exception);
        }
      })();

      function setupListboxes() {
        U.listboxConstructor(
          desktopListboxEle,
          function onChange(selectedOption) {
            updateCurrency(selectedOption.dataset.value);
          }
        );
        U.listboxConstructor(
          mobileListboxEle,
          function onChange(selectedOption) {
            updateCurrency(selectedOption.dataset.value);
          }
        );
      }

      function updateCurrency(isoCode) {
        console.log({
          isoCode,
        });
        hiddenCurrencyInput.value = isoCode;
        form.submit();
      }
      return Object.freeze({});
    }

    function CountrySelectorForm() {
      let desktopForm;
      let mobileForm;
      let desktopListboxEle;
      let mobileListboxEle;
      let hiddenDesktopInput;
      let hiddenMobileInput;
      (function init() {
        try {
          mobileForm = document.getElementById("mobile-country-selector-form");
          desktopForm = document.getElementById("top-bar-country-selector");
          if (!desktopForm || !mobileForm) {
            return;
          }
          desktopListboxEle = desktopForm.getElementsByClassName(
            "localization-selector"
          )[0];
          mobileListboxEle = mobileForm.getElementsByClassName(
            "localization-selector"
          )[0];
          hiddenDesktopInput = desktopForm.querySelector(
            "input[name='country_code']"
          );
          hiddenMobileInput = mobileForm.querySelector(
            "input[name='country_code']"
          );
          setupListboxes();
        } catch (exception) {
          console.log("Error setting up currency selector.", exception);
        }
      })();

      function setupListboxes() {
        U.listboxConstructor(
          desktopListboxEle,
          function onChange(selectedOption) {
            hiddenDesktopInput.value = selectedOption.dataset.value;
            desktopForm.submit();
          }
        );
        U.listboxConstructor(
          mobileListboxEle,
          function onChange(selectedOption) {
            hiddenMobileInput.value = selectedOption.dataset.value;
            mobileForm.submit();
          }
        );
      }
      return Object.freeze({});
    }

    function Subscribe() {
      const section = document.getElementsByClassName("subscribe")[0];
      if (!section) {
        return;
      }
      const forms = section.getElementsByTagName("form");
      const emailInput = document.getElementById("subscribe-by-email-input");
      const phoneInput = document.getElementById("subscribe-by-phone-input");
      (function init() {
        try {
          setupSliderInput();
          setupPhoneInput();
          setupEmailInput();
        } catch (exception) {
          console.log("Error setting up subscribe section.", exception);
        }
      })();

      function setupSliderInput() {
        const selector = document.getElementsByClassName(
          "subscribe-type-selector"
        )[0];
        const leftBtn = selector.getElementsByTagName("button")[0];
        const rightBtn = selector.getElementsByTagName("button")[1];
        leftBtn.addEventListener("click", function () {
          if (!leftBtn.classList.contains("is-active")) {
            selector.classList.remove("right-btn-is-selected");
            rightBtn.classList.remove("is-active");
            leftBtn.classList.add("is-active");
            forms[1].classList.add("is-hidden");
            forms[0].classList.remove("is-hidden");
          }
        });
        rightBtn.addEventListener("click", function () {
          if (!rightBtn.classList.contains("is-active")) {
            selector.classList.add("right-btn-is-selected");
            leftBtn.classList.remove("is-active");
            rightBtn.classList.add("is-active");
            forms[0].classList.add("is-hidden");
            forms[1].classList.remove("is-hidden");
          }
        });
      }

      function setupPhoneInput() {
        phoneInput.addEventListener(
          "focus",
          function () {
            phoneInput.parentElement.classList.add("is-focused");
          },
          true
        );
        phoneInput.addEventListener(
          "blur",
          function () {
            phoneInput.parentElement.classList.remove("is-focused");
          },
          true
        );
      }

      function setupEmailInput() {
        emailInput.addEventListener(
          "focus",
          function () {
            emailInput.parentElement.classList.add("is-focused");
          },
          true
        );
        emailInput.addEventListener(
          "blur",
          function () {
            emailInput.parentElement.classList.remove("is-focused");
          },
          true
        );
      }
      return Object.freeze({});
    }

    function AlertModal() {
      const alertModalEle = document.getElementById(
        "shopify-section-alert-modal"
      );
      if (!alertModalEle) {
        return;
      }
      const alertModal = Modal.init(alertModalEle);
      const alertElements = Array.from(
        alertModalEle.getElementsByClassName("alert")
      );

      function getAlertElementByName(name) {
        return alertElements.find((ele) => ele.dataset.name === name);
      }

      function showAlert(name, onResponse) {
        const alertElement = getAlertElementByName(name);
        const buttons = Array.from(alertElement.getElementsByClassName("btn"));
        alertModal.open();
        alertElement.classList.add("is-active");
        const confirmationCheckbox = alertElement.getElementsByClassName(
          "confirmation-checkbox"
        )[0];
        if (confirmationCheckbox) {
          if (confirmationCheckbox.checked) {
            buttons[1].disabled = false;
          }
          confirmationCheckbox.addEventListener("change", function () {
            if (confirmationCheckbox.checked) {
              buttons.forEach(function (button) {
                button.disabled = false;
              });
            } else {
              buttons.forEach(function (button) {
                if (button.dataset.response === "1") {
                  button.disabled = true;
                }
              });
            }
          });
        }
        const clickHandler = function () {
          alertModal.close();
          alertElement.classList.remove("is-active");
          let response = this.dataset.response;
          if (response === "1" || response === "0") {
            response = Number(response);
          }
          onResponse(response);
          if (confirmationCheckbox) {
            confirmationCheckbox.checked = false;
            if (response === 1) {
              this.disabled = true;
            }
          }
          removeClickHandlers();
        };
        buttons.forEach(function (button) {
          button.addEventListener("click", clickHandler, false);
        });

        function removeClickHandlers() {
          buttons.forEach(function (button) {
            button.removeEventListener("click", clickHandler, false);
          });
        }
      }
      return Object.freeze({
        showAlert,
      });
    }

    function FintechModal() {
      const fintechInfoModalEle = document.getElementById(
        "fintech-installment-payments-info-modal"
      );
      if (fintechInfoModalEle) {
        const fintechInstallmentModal = Modal.init(fintechInfoModalEle);
        const fintechModalTriggers = [
          ...Array.from(document.querySelectorAll(".fintech-modal-trigger")),
          document.getElementById("p-main-installment-payments-learn-more-btn"),
          document.querySelectorAll(
            ".p-main-installment-icons button.ratio-box"
          )[0],
          document.querySelectorAll(
            ".p-main-installment-icons button.ratio-box"
          )[1],
        ];
        fintechModalTriggers.forEach(function (btn) {
          if (btn) {
            btn.addEventListener("click", function () {
              fintechInstallmentModal.open();
              U.afterNextRepaint(function () {
                const modalHeading = fintechInfoModalEle.querySelector(
                  ".modal-content-heading"
                );
                const modalContent = fintechInfoModalEle.querySelector(
                  ".modal-content-inner"
                );
                modalContent.style.maxHeight = `calc(100% - ${modalHeading.offsetHeight}px)`;
              });
            });
          }
        });
      }
    }
  })((PLUG.Frame = Object.create(null)));
  (function initPlugJs() {
    let U;
    const globalComponents = ["Frame"];
    const capitalize = function (str) {
      const arr = str.split("");
      arr[0] = arr[0].toUpperCase();
      return arr.join("");
    };
    const camelCase = function (str) {
      const sepRegex = /[-_ .]+/g;
      return str
        .split(sepRegex)
        .map(function (val, i) {
          return i > 0 ? capitalize(val) : val;
        })
        .join("");
    };

    function initializeGlobalComponents() {
      globalComponents.forEach(function (componentName) {
        if (
          PLUG[componentName] &&
          typeof PLUG[componentName].init === "function"
        ) {
          PLUG[componentName].init();
        }
      });
      PLUG.import("Form").initAll();
      if (
        PLUG.template !== "product" &&
        PLUG.template !== "collection" &&
        PLUG.template !== "search" &&
        U
      ) {
        U.updateAllFavoriteButtons()
          .then(() => U.initWishlistButtons())
          .catch((e) => console.error(e));
      }
    }

    function initializeTemplate() {
      const templateName = capitalize(
        camelCase(PLUG.template.replace("page.", "").replace("customers/", ""))
      );

      const templateModule =
        templateName !== "Search"
          ? PLUG.import(templateName + "Template")
          : PLUG.import("CollectionTemplate");
      console.log("templateName",templateName);
      if (templateModule && typeof templateModule.init === "function") {
        templateModule.init();
        console.log("jjj");
        console.log(PLUG.template);
      } else {
        console.log("no template script detected");
        console.log(PLUG.template);
      }
    }

    function initializeEvents() {
      U = PLUG.import("Utils");
      const eventTarget = document.getElementById("main");
      PLUG.events = {
        mobileToDesktopResize: new Event("mobileToDesktopResize"),
        desktopToMobileResize: new Event("desktopToMobileResize"),
        windowResize: new Event("windowResize"),
        target: eventTarget,
      };
      let isMobile = U.isMobile();
      let resizeTimer;
      window.addEventListener("resize", function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          eventTarget.dispatchEvent(PLUG.events.windowResize);
          let wasMobile = isMobile;
          isMobile = U.isMobile();
          if (wasMobile && !isMobile) {
            eventTarget.dispatchEvent(PLUG.events.mobileToDesktopResize);
          } else if (!wasMobile && isMobile) {
            eventTarget.dispatchEvent(PLUG.events.desktopToMobileResize);
          }
        }, 100);
      });
    }
    (function init() {
      try {
        initializeEvents();
        initializeGlobalComponents();
        initializeTemplate();
      } catch (exception) {
        console.log("Initialization Error: ", exception);
      }
    })();
  })();
})();
